export const loanDetailsEn = {
  'A transaction still exists on this loan':
    'A transaction still exists on this loan',
  accountId: 'Account id',
  transactionCompletedNotificationDidNotSend:
    'Transaction completed notification did not send',
  accountToken: 'Account Token',
  accountNumber: 'Account Number',
  activity: 'Activity Logs',
  Activity: 'Activity Logs',
  activityDate: 'Activity Date',
  agreementDate: 'Date Agreement',
  alreadyPaid: 'Already Paid',
  areYouSureYouWantMarkLoanForSale: 'Are you sure you want mark loan for sale?',
  autoPayment: 'Auto Payment',
  autoPaymentParameters: 'Auto Payment Parameters',
  availableForSale: 'Available for Sale',
  bankAccount: 'Bank Account',
  bankName: 'Bank Name',
  'Change rate': 'Change Rate',
  chargesAddedValueLoan: 'Charges added to the value of the loan',
  chargesDeductedDisbursement: 'Charges deducted at disbursement',
  changeLoanStatusDescription: 'Select Destination Status',
  changeStatus: 'Change Status',
  'Charge amount': 'Charge Amount',
  company: 'Company',
  Complete: 'Complete',
  currentStatus: 'Current State',
  customerDetails: 'Borrower Details',
  'Delete loan installment': 'Delete Loan Installment',
  destinationState: 'Destination State',
  disbAmountLabel: 'Disbursement Amount',
  disbAmtExceedsLoanAmt: 'The disbursement amount exceeds the loan amount.',
  generateDisbursementFile: 'Generate batch disbursement file',
  disburse: 'Disburse',
  disbursedAmount: 'Disbursed Amount',
  disburseLabelBtn: 'Disburse',
  disburseLoan: 'Disburse Loan',
  'Disbursement transaction made.': 'Disbursement Transaction Made.',
  dontAnswer: 'Did not answer',
  download: 'Download',
  downloadDisbFileSubTtl:
    'Select account and date in order to generate the disbursement file',
  downloadDisbFileTtl: 'Downloand Disbursement File',
  loanEffectiveDate: 'Effective Date',
  loanEffectiveDateCapital: 'Effective Date',
  paymentDueDate: 'Due',
  enterCustomerNameIdentification: 'Enter borrower name or identification',
  enterProductNameId: 'Enter name or identification product',
  entity: 'Entity',
  EquatedInstallments: 'Equated Installments',
  evidences: 'Evidences',
  'Existe un préstamo activo para la solicitud.':
    'There is an active loan for the application.',
  fileDeleted: 'File deleted',
  filesAreRequired: 'Files are required',
  from: 'From',
  getLoanInfoFailed: 'Loan not found',
  'Grace period': 'Grace Period',
  'Grace period for': 'Grace Period For',
  'Grace periods': 'Grace Periods',
  'Grace periods apply for': 'Grace Periods Apply For',
  'Has grace period?': 'Has Grace Period?',
  inactive: 'Inactive',
  incorrectNumber: 'Incorrect Number',
  'Installment amount': 'Installment Amount',
  totalDueAmount: 'Total Due Amount',
  'Installment of': 'Installment of',
  'Installment type': 'Installment Type',
  'Interest amount': 'Interest Amount',
  interestRate: 'Interest Rate',
  'La fecha inicial de pago no puede ser menor a la fecha de la transacción. ':
    'The initial payment date cannot be less than the date of the transaction.',
  'La solicitud debe estar en estado Iniciada para poder ser borrada. ':
    'The application must be in the Started state in order to be deleted.',
  lastTranDisbError:
    'The disbursement date cannot be less than the last transaction date.',
  loan: 'Loan',
  'Loan details': 'Loan details',
  'Loan Rescheduling': 'Loan Rescheduling',
  loanCode: 'Loan Code',
  loanCodeCapital: 'Loan Code',
  loanAmount: 'Loan Amount',
  prLoanAmount: 'Loan Amount',
  loanAvailableForSale: 'Loan Available for Sale',
  loanChanged: 'Loan Status Changed',
  loanChangeNoAllowed: 'Loan Status Change no allowed',
  loanDetails: 'Loan Details',
  loanInstallment: 'Loan Installment',
  loanManagement: 'Loan Management',
  loanNoFound: 'Loan no found',
  loanRequest: 'Loan Application',
  loanRequestValidations: 'Loan Application Validations',
  loanlist: 'Loan Portfolio',
  loansId: 'ID',
  loanToFactorDetails: 'Loan to Factory Details',
  loanTransaction: 'Loan Transaction',
  loanTransactions: 'Loan Transactions',
  loanValidations: 'Loan Validations',
  loanWithNoRepaymentSchedule: 'Loan with no repayment schedule',
  markForSale: 'Mark for Sale',
  noAllowedTransactions: 'This transaction is not allowed for this loan status',
  noAllowedTransactionsMenu: 'No allowed transactions',
  noContentFile: 'No disbursement files found.',
  noInvestorForLoan: 'There are no investor to assign to the loan.',
  noMultipleDisbAllowed: "The product doesn't allow multiple disbursements.",
  NonEquatedInstallments: 'Non Equated Installments',
  notAbleToPay: 'Not able to pay',
  notValidated: 'Not validated',
  numberInstallmentsMustGreaterEqualOne:
    'Number of installments must be greater than or equal to 1',
  numberInstallmentsExceedMaximumDate:
    'The number of installments exceed the maximum date 2100-01-01',
  'Number of installments': 'Number of Installments',
  numberOfInstallments: 'Number of Installments',
  observations: 'Observations',
  'Overdue date': 'Overdue Date',
  Overview: 'Overview',
  pay: 'Pay',
  Pay: 'Pay',
  'Paid amount': 'Paid Amount',
  paidAmount: 'Paid Amount',
  totalPaidAmount: 'Total Paid Amount',
  'Paid interest amount': 'Paid Interest Amount',
  paidInterestAmount: 'Paid Interest Amount',
  'Paid penal amount': 'Paid Penalty Amount',
  paidPenalAmount: 'Paid Penalty Amount',
  'Paid principal amount': 'Paid Principal Amount',
  paidPrincipalAmount: 'Paid Principal Amount',
  paidChargeAmount: 'Paid Charge Amount',
  'Payment start date': 'Payment Start Date',
  paymentStartDate: 'Payment Start Date',
  paymentMethodDisburse: 'Disburse Method',
  paymentPlan: 'Payment Plan',
  paymentPlanRestructured: 'Payment Plan Restructured',
  historicalPaymentPlan: 'Historical Payment Plan',
  'Penal amount': 'Penalty Amount',
  penalRate: 'Penalty Rate',
  pendingAmount: 'Outstanding Amount',
  outstandingPrincipal: 'Outstanding',
  pendingPrincipal: 'Pending Principal',
  outstandingBalance: 'Outstanding Balance',
  pendingLoanInstallmentsExist:
    'There are pending installments with date greater than the disbursement date.',
  'Principal amount': 'Principal Amount',
  productType: 'Product Type',
  pymtLessFromDateError:
    'Payment start date cannot be less than Rescheduling from date',
  pymtStartDateLabel: 'Payment Start Date',
  insurancePaymentDate: 'Insurance Payment Date',
  insuranceExpirationDate: 'Insurance Expiration Date',
  pymtStartDateNotLessThanDisbDate:
    'Payment start date cannot be less than disbursement date.',
  'Raised?': 'Generated?',
  'Re-schedule': 'Restructure',
  'Record deleted successfully': 'Record deleted successfully',
  registerPaymentReceived: 'Register Payment',
  reluctantToPay: 'Does not want to pay',
  Reschedule: 'Reschedule',
  'Reschedule from date': 'Reschedule From Date',
  rescheduleFromDate: 'Reschedule From Date',
  'Rescheduling parameters': 'Restructure Parameters',
  reschedulingParametersr: 'Restructure Parameters',
  'Rescheduling successful message':
    'Rescheduling of loan payment plan has been completed successfully.',
  reverseLblBtn: 'Reverse',
  reverseTransaction: 'Reverse Transaction',
  reversionDoneCorrectly: 'Reversion done correctly.',
  reviewValidationsIncompleteValidations:
    'Validations are required prior to loan disbursement',
  routingNumber: 'Routing Number',
  'Start date': 'Start Date',
  Tenor: 'Term',
  to: 'to',
  tranDateLabel: 'Transaction Date',
  transactionCompleted: 'Transaction completed',
  transactionSuccessful: 'Transaction processed successfully',
  undefined: 'Undefined',
  validated: 'Validated',
  'View loan': 'View Loan',
  waived: 'waived',
  Waived: 'Waived',
  writeAShortReverseTran:
    'Write a short description about why this transaction is getting reversed.',
  'You are all done!': 'You are all done!',
  successfullyDisbursed: 'Successfully disbursed.',
  successfullyDisbursedNotificationNotSent:
    'Successfully disbursed. Notification not sent.',
  successfullyDisbursedTasksWithoutUserAssignment:
    'Successfully disbursed. Tasks created without user assigned.',
  successfullyDisbursedNotificationNotSentTasksWithoutUserAssignment:
    'Successfully disbursed. Notification not sent. Tasks created without user assigned. ',
  debtCollectionActivityAdded: 'Debt collection activity added',
  debtCollectionActivitiesDontLoaded: 'Debt collection activities did not load',
  currentPaymentPlan: 'Current Payment Plan',
  inAnotherDisbursementFile:
    'The loans have already been disbursed in another file.',
  someLoansAlreadyHaveDisbursementFilesAssociated:
    'Some loans already have disbursement files associated with them.',
  disbursementFileIsNotAvailablePerBank:
    'The disbursement file is not available for the selected Bank account.',
  daysPastDue: 'Days Past Due',
  paymentMethods: 'Paymenth Methods',
  transactionCompletedNotificationSent:
    'Transaction completed notification sent',
  paymentStarDateRestructuringDate:
    'The payment start date cannot be less than the rescheduling date',
  restructuringDateCannotToday:
    'The rescheduling date cannot be later than today',
  unpaidInstallmentsRestructuring:
    'There cannot be unpaid installments at the time of rescheduling, delete the generated installments and try again',
  installmentsPaymentStartDate:
    'There cannot be installments with a date greater than the payment start date, delete the generated installments and try again',
  installmentsGeneratedWithRestructuringDate:
    'There cannot be installments generated with a date greater than the rescheduling date, delete the generated installments and try again',
  noGracePeriods: 'No grace periods are allowed for this product',
  maximunNumberRestructurings:
    'Cannot exceed the maximum number of reschedulings for this product.',
  exceedDaysRestructuring:
    'The term of the new schedule cannot exceed the parameterized days.',
  gracePeriodValuesnotValid: 'Grace period values are not valid.',
  confirmPayment: 'Confirm Payment',
  areYouSureYouWantToInitiateACHPayment:
    'Are you sure you want to initiate a payment usign ACHQ for this loan?',
  thereIsTransactionInPendingStatus: 'There is a transaction in pending status',
  nextPaymentDate: 'Next Payment Date',
  installmentAmount: 'Next Payment Amount',
  externalCode: 'Loan Code',
  installmentDate: 'Installment Date',
  payDate: 'Payment Date',
  payOffInfo: 'Payoff Information',
  payOff: 'Payoff',
  currentPayment: 'Current',
  day: 'Day',
  paymentDate: 'Payment Date',
  dailyChange: 'Daily Change',
  sendEmailTo: 'Send Email to',
  principalContactEmail: 'Principal Contact Email',
  addEmailContacts: 'Add Email Contacts',
  emailContacts: 'Email Contact(s)',
  addEmailToSendDocument: 'Add Email(s) to Send Document',
  addedEmails: 'Added Email(s)',
  addEmail: 'Add Email',
  sendDocument: 'Send Document(s)',
  payOffNotGenerated: 'Payoff did not generate',
  notExistEmailForThisContact: 'Does not exist email for this contact',
  unexpectedErrorSendingEmail: 'Unexpected error sending email',
  payOffSentSuccessfully: 'Payoff sent successfully',
  payOffSentToAllEmailsSuccessfully: 'Payoff sent to all emails successfully',
  prepaymentPenalty: 'Prepayment Penalty',
  totalAmount: 'Total Amount',
  sendStatement: 'Send Statement',
  doesNotExistInstallmentsForThisLoan:
    'Does not exist installments for this loan',
  noCompleteDataForLoanStatement: 'No complete data for the loan statement',
  statementSentToAllEmailsSuccessfully:
    'Statement sent to all emails successfully',
  statementSentSuccessfully: 'Statement sent successfully',
  validationDisbursWithChargeDiscount:
    'The disbursement value cannot be less than the loan amount as the product has fees that will be disbursed at the loan amount.',
  quotaValues: 'Amount Due',
  paidQuotaValues: 'Amount Paid',
  transactions: 'Transactions',
  paymentMethod: 'Payment Method',
  paymentMethodCapital: 'Payment Method',
  dailyReport: 'Daily Report',
  weeklyReport: 'Weekly Report',
  payments: 'Payments',
  general: 'General',
  delinquentSince: 'Delinquent Since',
  amountToBePaid: 'Amount Due',
  delinquency: 'Delinquency',
  delinquencyStatus: 'Delinquency Status',
  delinquencyReport: 'Delinquent Report',
  delinquencyReports: 'Delinquency Reports',
  paymentProcessing: 'Payment Processing',
  extensionActive: 'Extensions',
  loansChargedOff: 'Charged-off',
  loansDeferral: 'Deferrals',
  noExistDelinquencyStatus: 'There is no exist this delinquency status',
  noTransactionInformation: 'There is no information about transactions',
  AUpdateDate: 'Approval Date',
  PUpdateDate: 'Start Date',
  RUpdateDate: 'Rejection Date',
  installmentPeriod: 'Installment Period',
  previousPrincipalBalance: 'Previous Principal Balance',
  currentPrincipalBalance: 'Current Principal Balance',
  dueDateCapital: 'Due Date',
  dailyPayments: 'Daily Payments',
  of: 'of',
  show: 'Details',
  notes: 'Notes',
  addNotes: 'Add Notes',
  subject: 'Subject',
  description: 'Description',
  noNotes: 'No notes registered',
  noStatements: 'No statement(s) registered',
  loanNoteAddedSuccessfully: 'Note added successfully',
  noExistLoanNotes: 'There are no notes',
  noteAttachmentNotExist: 'There is no exist this file',
  loanReports: 'Loan Reports',
  loanTerms: 'Loan Terms',
  loanParticipation: 'Loan Participation',
  stateGuaranteeReport: 'State Guarantee',
  borrower: 'Borrower',
  loanStatus: 'Loan Status',
  chargedOff: 'Charged Off',
  chargedOffInformation: 'Charge Off Information',
  loanNumber: 'Loan Number',
  borrowerName: 'Borrower Name',
  firstPaymentDate: 'First Payment Date',
  monthlyPaymentAmount: 'Monthly Payment Amount',
  attachmentDeletedSuccessfully: 'Attachment successfully deleted',
  deleteAttachment: 'Delete attachment',
  loanNoteDeletedSuccessfully: 'Loan note successfully deleted',
  loanNoteUpdatedSuccessfully: 'Loan note updated successfully',
  loanNotesLoadedSuccessfully: 'Loan note loaded successfully',
  noExistAttachment: 'No exist attachment',
  startTyping: 'Start typing',
  deleteNote: 'Delete note',
  priorPrincipalBalance: 'Prior Principal',
  principalAmount: 'Principal',
  interestAmount: 'Interest',
  penaltyFees: 'Fees',
  totalPaid: 'Total Paid',
  paymentReport: 'Payment Report',
  showPaymentReport: 'Show Payment Report',
  reportSentToAllEmailsSuccessfully: 'Report sent to all emails successfully',
  reportNotGenerated: 'Payment report dit not generate',
  paymentReportSentSuccessfully: 'Payment report sent successfully',
  sendPaymentReport: 'Send payment report',
  paymentExecutionDate: 'Payment Execution Date',
  paymentExecutionDateCapital: 'Payment Execution Date',
  dateReceived: 'Cleared',
  noExistPrincipalEmailContact:
    'No main contact email found. Please set up a main contact.',
  areYouSureThisEmailContact:
    'Are you sure you want to send the document to this email?',
  fromDate: 'From',
  toDate: 'To',
  period: 'Period',
  pmtMethod: 'Method',
  fees: 'Fees',
  originalInvoice: 'Original Invoice',
  payment: 'Payment',
  downloadExcel: 'Download Excel',
  downloadPdf: 'Download Pdf',
  sendFileToEmails: 'Send file to email(s)',
  executed: 'Executed',
  received: 'Cleared',
  noDataFoundForReport: 'No data found for report',
  fileType: 'File type',
  yourLoan: 'Your Loan',
  charges: 'Charges',
  totalAmountDue: 'Total Amount Due',
  pastDueAmount: 'Past Due Amount',
  currentlyMonthlyDue: 'Currently Monthly Installment Due',
  installment: 'Installment',
  linkToPay: 'Link to Pay',
  copyLinkAndSendToCustomer: 'Copy link and send to customer',
  copy: 'Copy',
  thisIsLinkToPay: 'This is the link to pay',
  loanNotFound: 'Loan not found',
  paymentLinkCreatedSuccessfully: 'Payment link created successfully',
  termConditions: 'Terms and Conditions',
  newPayment: 'New payment',
  paymentLinkIsInvalid: 'The payment link is invalid',
  disagree: 'Disagree',
  agree: 'Agree',
  areYouSureUseThisService:
    'Are you sure you what to use this service to pay your loan?',
  paymentLink: 'Payment Link',
  downloadStatement: 'Download Statement Document',
  downloadPaymentPlan: 'Download Payment Plan',
  setAutoPaymentInfo: 'Set Auto-payment Info',
  setAutoPayment: 'Auto-payment Info',
  autoPaymentInfoUpdatedSuccessful: 'Auto-Payment Info Updated Successful',
  areYouSureSendLinkThisEmailContact:
    'Are you sure you want to send the link to update the auto-payment information to this email?',
  setPaymentInfoSentSuccessfully:
    'Link to update the auto-payment information sent successfully',
  sendLinkUpdateAutoPaymentInfo: 'Send link to update Auto-payment info',
  confirmSetAutoPayment: 'Confirm update Auto-payment',
  areYouSureYouWantToUpdateAutoPayment:
    'Are You Sure You Want To update Auto-payment Info?',
  paymentExtension: 'Payment Extension',
  dateForPaymentExtension: 'Date for Payment Extension',
  paymentExtensionAddedSuccessfully: 'Payment extension successfully added',
  extensions: 'Extensions',
  extensionAttachmentNotExist: 'Attachment Not Exist',
  loanPayments: 'Payments',
  active: 'Active',
  hasExtension: 'Extension',
  overdue11To30: 'Overdue 11 to 30',
  overdue30To59: 'Overdue 30 to 59',
  overdue60To89: 'Overdue 60 to 89',
  overdue90OrMore: 'Overdue 90 or more',
  delinquent31To59: 'Delinquent 31 to 59',
  delinquent60To89: 'Delinquent 60 to 89',
  delinquent90OrMore: 'Delinquent 90 or more',
  useCurrentAccount: 'Use current account',
  noHasPaymentAccountConfigured: 'No has payment account configured',
  noHasAutoPaymentParametersConfig: 'No has auto-payment parameters configured',
  noPaymentExtensions: 'No payment extensions registered',
  isPartialPayment: 'Partial Payment',
  requiredPartialPaymentIsChecked:
    'Partial payment is checked, you must enter the amount',
  ifPartialPayPaymentAmountMustBeGreaterThatZero:
    'If partial payment, the amount must be greater than zero.',
  noPaymentExtensionConfigured: 'No payment extension configured',
  removeExtension: 'Remove Extension',
  loanPaymentExtensionDeletedSuccessfully:
    'Extension of payment successfully deleted',
  paymentLinkProcess: 'Payment Link',
  automaticPayment: 'Automatic Payment',
  createdByCapital: 'Created By',
  dateCreated: 'Date Created',
  approved: 'Approved',
  amountApplied: 'Amount Applied',
  statements: 'Statements',
  addStatement: 'Add Statement',
  loanStatementsLoadedSuccessfully: 'Loan Statement(s) loaded successfully',
  loanStatementAttachmentDeletedSuccessfully:
    'Loan Statement attachment deleted successfully',
  loanStatementAttachmentNotExist: 'Loan Statement not exist',
  loanStatementSavedSuccessfully: 'Loan Statement saved successfully',
  dateClosed: 'Closed Date',
  paymentLinkHasExpired:
    'Your payment link has expired! Contact us for a new payment link.',
  paymentLinkWillBeValid:
    'The payment link will be valid for 10 days, after which it will expire. You will have to contact us for a new payment link.',
  paymentLinkWillExpired: 'The payment link will expire',
  balanceAmount: 'Balance Amount',
  defaultDate: 'Default Date',
  numberOfPaymentsReceived: 'Number of Payments Received',
  numberOfPaymentsMissed: 'Number of Payments Missed',
  principalLoanBalance: 'Principal loan balance as of date of default',
  expensesIncurred: 'Expenses Incurred',
  repossession: 'Repossession',
  repairs: 'Repairs',
  Insurance: 'Insurance',
  otherExpensesIncurred: 'Other(s) Expenses Incurred',
  paymentCollected: 'Payments Collected',
  liquidationProceeds: 'Liquidation Proceeds',
  insuranceRefund: 'Insurance Refund',
  otherPaymentCollected: 'Other(s) Payments Collected',
  informationUpdatedSuccessfully: 'Information updated successfully',
  informationReportIsEmpty: 'Information report is empty',
  editChargeOffInformation: 'Edit Charge Off Information',
  markAsSold: 'Mark as Sold',
  areYouSureYouWantMarkLoanAsSold:
    'Are you sure you want to mark the loan as sold?',
  sold: 'Sold',
  processed: 'Processed',
  initialPeriod: 'Initial Period',
  beginningPrincipalBalance: 'Beginning Balance',
  interest: 'Interest',
  installments: 'Total Installments',
  endingPeriod: 'Ending Period',
  endingPrincipalBalance: 'Ending Balance',
  loansReceivable: 'Loans Receivable',
  totalPayments: 'Total Payments',
  accountsReceivableAging: 'Accounts Receivable Aging',
  agingMethod: 'Aging Method',
  current: 'Current',
  andOver: 'and Over',
  numberOfPeriods: 'Number of Periods',
  periods: 'Periods',
  amountAppliedCapital: 'Amount Applied',
  pendingAmountCapital: 'Pending Amount',
  portfolioBalance: 'Portfolio Balance',
  method: 'Method',
  totalPrincipal: 'Total Principal',
  totalInterest: 'Total Interest',
  totalFees: 'Total Fees',
  paid: 'Paid',
  loanClosure: 'Loan Closure',
  files: 'Files',
  guaranteePaymentRequested: 'Guarantee Payment Requested',
  batchNumber: 'Batch Number',
  purchaseDate: 'Purchase Date',
  purchaseAmount: 'Purchase Amount',
  premiumAmountPaid: 'Premium Amount Paid',
  numberOfPaymentsMade: 'Number of Payments Made',
  paymentsOfPrincipalMade: 'Payments of Principal Made',
  principalBalanceDue: 'Principal Balance Due',
  replaceOrMakeWhole: 'Replace or Make Whole',
  editLoanParticipation: 'Edit Loan Participation',
  iBankLoanNumber: 'IBank Loan Number',
  guaranteeAssignmentDate: 'Guarantee Date',
  dateDemandLetterSubmitted: 'Date Demand Letter Submitted',
  dateOfLastPaymentReceived: 'Date of Last Payment Received',
  defaultCalculation: 'Default Calculation',
  principalBalanceDueAtDefault: 'Principal Balance Due at Default',
  repossessionExpenses: 'Repossession Expenses',
  adjustedPrincipalAmount: 'Adjusted Principal Amount',
  ninetyDaysOfInterest: '90 Days of Interest',
  totalLoss: 'Total Loss',
  editLoanStateGuarantee: 'Edit Loan State Guarantee',
  guaranteedPrincipalAmount: 'Guaranteed Principal Amount',
  interestAmountDue: 'Interest Amount Due',
  totalGuaranteePaymentRequested: 'Total Guarantee Payment Requested',
  amountReceivedFromState: 'Amount Received from State',
  unrecoveredLosses: 'Unrecovered Losses',
  editLoanGuaranteePaymentRequested: 'Edit Guarantee Payment Requested',
  guaranteedPrincipalPercent: 'Guaranteed Principal Percent',
  interestAmountDuePercent: 'Interest Amount Due Percent',
  reportNotExist: 'This report does not exist',
  loanClosureFilesSavedSuccessfully: 'Closure files saved successfully',
  loanClosureFilesNotExist: 'Closure files do not exist',
  loadedSuccessfully: 'Loaded successfully',
  reportGenerated: 'Report generated',
  loanClosureFileDeletedSuccessfully: 'Closure file deleted successfully',
  uploadedFiles: 'Uploaded File(s)',
  deleteFile: 'Delete File',
  notificationSentSuccessfully: 'Notification sent successfully',
  readyToChargedOff: 'Ready to be charged off',
  noFilesUploaded: 'No file(s) uploaded',
  sendNotification: 'Send Notification',
  areYouSureYouWantSendNotification:
    'Are you sure you want to send the notification?',
  youMustUploadLoanClosureFiles: 'You must upload loan closure files',
  'One Dark': 'One Dark',
  Acelera: 'Acelera',
  accounting: 'Accounting',
  dashboard: 'Dashboard',
  accountsReceivableSummary: 'Accounts Receivable Summary',
  yearToDateLoansReceivableSummary: 'Year to Date Loans Receivable Summary',
  dashboardOverview: 'Overview',
  numberOfLoansFunded: 'Loans Funded',
  totalLoanPortfolioValue: 'Current Loan Portfolio Value',
  averageLoanAmount: 'Average Loan Amount',
  averageInterestRate: 'Average Interest Rate',
  averageOriginationFee: 'Average Origination Fee',
  averageFicoCreditScore: 'Average FICO Credit Score',
  loanBuyerOverview: 'Loans Sale Overview',
  numberOfLoansSold: 'Number of Loans Sold',
  valueOfLoansSold: 'Value of Loans Sold',
  averagePremiumAmount: 'Average Premium Amount',
  expirationDateUpdatedSuccessfully: 'Expiration date updated successfully',
  insuranceExpirationInformation: 'Insurance Expiration Information',
  showInsuranceExpirationInformation: 'Show Insurance Expiration Information',
  insuranceCompanyName: 'Insurance Company',
  insuranceBrokerName: 'Insurance Broker Name',
  insuranceBrokerEmail: 'Insurance Broker Email',
  insuranceBrokerPhone: 'Insurance Broker Phone',
  insuranceExpirationDateCapital: 'Insurance Expiration Date',
  noExistInsuranceExpirationInfo:
    'Does not exist Insurance Expiration Information',
  insuranceExpirationCreateOrUpdatedSuccessfully:
    'Insurance Expiration create or updated successfully',
  vinCode: 'VIN Code',
  insuranceAmount: 'Insurance Amount',
  hasCollectionActivity:
    'This contact has collection notifications. You can not delete it',
  inputDateLastInstallment: 'Should be the date of the last installment paid',
  numberInstallmentRemainingAddingGracePeriod:
    'Input the number of installments remaining adding the grace period(s)',
  inputDateInstallmentToBeDeffered:
    'Input the date of the installment to be deffered',
  inputNumberOfGracePeriod:
    'Input the number of the grace period to be granted',
  liquidatedCollateralAmount: 'Liquidated Collateral Amount',
  accruedInterestAmount: 'Accrued Interest Amount',
  downloadDemandLetter: 'Download Demand Letter',
  demandLetterSentToAllEmailsSuccessfully:
    'Demand Letter sent to all emails successfully',
  defaultAndRepossession: 'Default and Repossession',
  chargedOffDate: 'Charged Off Date',
  reasonForChargeOff: 'Reason for Charge Off',
  repossessionDate: 'Repossession Date',
  repossessionType: 'Repossession Type',
  repossessionCompanyName: 'Repossession Company Name',
  repossessionCost: 'Repossession Cost',
  conditionOfCollateral: 'Condition of Collateral',
  priceDigestValue: 'Price Digest Value',
  liquidationDate: 'Liquidation Date',
  liquidationAmount: 'Liquidation Amount',
  nameOfBuyer: 'Name of Buyer',
  voluntary: 'Voluntary',
  involuntary: 'Involuntary',
  good: 'Good',
  poor: 'Poor',
  damaged: 'Damaged',
  totalLost: 'Total Lost',
  attachConditionReport: 'Attach Condition report',
  attachPriceDigestReport: 'Attach Price Digest report',
  attachBillSaleAndInvoice: 'Attach Bill of Sale And Invoice',
  notSelected: 'Not Selected',
  noExistDefaultAndRepossession: 'No exist Default and Repossession',
  informationSavedSuccessfully: 'Information saved successfully',
  attachmentsTo: 'Attachment(s) to ',
  editDefaultAndRepossession: 'Edit Default and Repossession',
  loanSaleDetails: 'Sale Details',
  amountPurchased: 'Amount Purchased',
  continuePaymentOrMakeWhole: 'Continue Payment or Make Whole',
  continuePayment: 'Continue Payment',
  makeWhole: 'Make Whole',
  editLoanSaleDetails: 'Edit Sale Details',
  investorName: 'Name',
  getDataFromOpEx: 'Get Data from OpEx',
  getSaleDetailsFromExternalService: 'Get Sale Details from External Service',
  loanHasNotBeenSoldYet: 'The loan has not been sold yet',
  stateGuaranteeNotFound: 'State Guarantee did not find',
  dateDemandLetterSubmittedNotExist:
    'Date Demand Letter Submitted does not exist',
  dateDemandLetterIsLessThanDateLastPaymentMade:
    'Date Demand Letter is less than Date Last Payment Made',
  getSaleDetails: 'Get Sale Details',
  dateOfLastPaymentMadeToInvestor: 'Date of Last Payment Made to Investor',
  dateOfLastPaymentMade: 'Date of Last Payment Made',
  investor: 'Investor',
  investorAddress: 'Address',
  investorEmail: 'Email',
  downloadDraftNoticeDefaultInvestorV1:
    'Download Draft Default Notice to Investor V1',
  dateOfNoticeLoanDefaultToInvestor: 'Date of Default Notice to Investor',
  dateOfNoticeLoanDefault: 'Date of Default Notice',
  sendDraftDocumentToEmails: 'Send Draft Document to Emails',
  signOffOnAmountsAndCalculations: 'Sign Off on Amounts and Calculations',
  areYouSureYouWantToSignOffOnAmountsAndCalculations:
    'Are you sure you want to sign off on Amounts and Calculations?',
  saleDetailsNotFound: 'Sale Details not found',
  dateOfLastPaymentMadeToInvestorNotExist:
    'Date of Last Payment Made to Investor does not exist',
  noExistNotification: 'Notification not exist',
  noticeLoanDefaultSentToAllEmailsSuccessfully:
    'Default Notice sent to all emails successfully',
  fileSavedSuccessfully: 'File saved successfully',
  sendNoticeLoanDefaultToInvestor: 'Send Default Notice to Investor',
  sendNoticeToInvestor: 'Send Default Notice to Investor',
  areYouSureYouWantToSendNoticeToInvestor:
    'Are you sure you want to send default notice to Investor?',
  investorEmailIsNotValid: 'Investor email is not valid',
  noticeLoanDefaultSentSuccessfully: 'Default Notice sent successfully',
  emailSentToServicingAndFileSavedSuccessfully:
    'Email sent to servicing and file saved successfully',
  fileSavedSuccessfullyErrorSendingServicingEmail:
    'File saved successfully but, with an error sending Servicing email',
  downloadDraftDemandLetter: 'Download Draft Demand Letter',
  signOnDemandLetter: 'Sign Off on the Demand Letter',
  areYouSureYouWantToSignOnDemandLetter:
    'Are you sure you want to sign off on the Demand Letter?',
  sendSignedDocumentToEmails: 'Send Signed Document to Email(s)',
  addEmailsToSendDocumentAsToAndCc:
    'Add Email(s) to Send Document(s) of Recipient and Cc',
  addEmailAsTo: 'Add Email(s) of Recipient',
  addedEmailsAsTo: 'Added Email(s) of Recipient',
  emailAsTo: 'Email of Recipient',
  addEmailAsCc: 'Add Email(s) for Cc',
  addedEmailsAsCc: 'Added Email(s) for Cc',
  emailAsCc: 'Email for Cc',
  insuranceReport: 'Insurance Policies',
  expirationDate: 'Expiration Date',
  fortyFiveDays: '45 Days',
  thirtyDays: '30 Days',
  tenDays: '10 Days',
  zeroDays: '0 Day',
  insuranceNoteAddedSuccessfully: 'Insurance Note added successfully',
  noExistInsuranceNote: 'No exist Insurance Note',
  updatedSuccessfully: 'Updated successfully',
  deletedSuccessfully: 'Deleted successfully',
  attachmentNotExist: 'There is no exist this file',
  insurance: 'Insurance',
  addInsuranceNote: 'Add Insurance Note',
  deleteInsuranceNote: 'Delete Insurance Note',
  noInsuranceNotes: 'No insurance notes registered',
  expired: 'Expired',
  sent: 'Sent',
  buyerInformation: 'Buyer Information',
  state: 'State',
  zip: 'Zip',
  vehicleCollateralDetails: 'Vehicle Collateral Details',
  vin: 'VIN',
  licensePlate: 'License Plate',
  saleAmount: 'Sale Amount',
  saleDate: 'Sale Date',
  billOfSale: 'Bill of Sale',
  downloadDraftBillOfSale: 'Download Draft Bill of Sale',
  editBillOfSale: 'Edit Bill of Sale',
  downloadDraftInvoice: 'Download Draft Invoice',
  documentsSentToAllEmailsSuccessfully:
    'Document(s) sent to all email(s) successfully',
  billOfSaleNotFound: 'Bill of Sale not found',
  emailSubject: 'Subject',
  emailBody: 'Body',
  generateAndSend: 'Generate and Send Documents',
  areYouSureYouWantToSendFiles: 'Are you sure you want to send the file(s)?',
  confirmSendFilesToEmails: 'Confirm Send Files to Email(s)',
  created: 'Created',
  updated: 'Updated',
  downloadFilteredReport: 'Download filtered report',
  downloadActiveInsuranceReport: 'Download active Insurance report',
  insPolicyOnFile: 'Ins. Policy on File',
  buyer: 'Buyer',
  invoiceNumber: 'Invoice Number',
  invoice: 'Invoice',
  collateral: 'Collateral',
  collateralReport: 'Collateral Sale Report',
  downloadAllCollateralReport: 'Download all Collateral report',
  coi: 'COI',
  paymentCycle: 'Payment Cycle',
  cycle1st: '1st',
  cycle15th: '15th',
  downloadDraftNoticeDefaultInvestor: 'Download Draft Default Notice',
  defaultedLoansReport: 'Defaulted Loans',
  ibank: 'IBank',
  submitted: 'Submitted',
  initialLoan: 'Initial Loan',
  defaultedBalance: 'Defaulted Balance',
  principalPaid: 'Principal Paid',
  pmtsMade: 'Pmts Made',
  defaulted: 'Defaulted',
  equipment: 'Equipment',
  initial: 'Initial',
  liquidation: 'Liquidation',
  monthOfDefault: 'Month of Default',
  daysToReceiveStateGuarantee: 'No of Days to Receive State Guarantee',
  downloadAllLoansReport: 'Download Report',
  eQLoanListReport: 'Sold Loans',
  contract: 'Contract',
  customerName: 'Customer Name',
  financing: 'Financing',
  downPmt: 'Down Payment',
  closing: 'Closing Costs',
  date: 'Date',
  int: 'Int',
  batch: 'Batch',
  monthlyPmt: 'Monthly Payment',
  loanSold: 'Loan Sold',
  loanSales: 'Loan Sales',
  pd: 'Pd.',
  statementCycle: 'Statement Cycle',
  percentSold: 'Percent Sold',
  premiumFee: 'Premium Fee',
  servicingFee: 'Servicing Fee',
  acqEffective: 'Acq. Effective',
  balance: 'Balance',
  premium: 'Premium',
  loanPurchase: 'Loan Purchase',
  investment: 'Investment',
  mthPmt: 'Monthly Payment',
  irr: 'IRR',
  calculateIrr: 'Calculate IRR',
  dummy: 'Dummy',
  periodPurchased: 'Purchased Period',
  successfullyButErrorInOpex: 'Successfully, but there was an error in Opex',
  transactionDetails: 'Transaction Details',
  installmentDetails: 'Installment Details',
  termDate: 'Term',
  filteredBy: 'Filter by',
  amountDue: 'Amount Due',
  dateNotice: 'Notice Date',
  stateGuaranteeLoans: 'IBank Loans',
  vintagePortfolioLoans: 'Vintage Portfolio Loans',
  vintagePortfolio: 'Vintage Portfolio: 2021 - 2023',
  numberOfDefaultedLoans: 'Number of Defaulted Loans',
  defaultRate: 'Default Rate',
  ibankAmount: 'IBank Received Amount',
  calCapLoans: 'CalCAP SB Loans',
  currentProgramLoans: 'Current Program Loans',
  noRegistered: 'No Registered',
  showLoansFunded: 'Show Loans Funded',
  showDefaultedLoans: 'Show Defaulted Loans',
  showLoansSold: 'Show Loans Sold',
  daysLate: 'Days Late',
  creditEnhancementType: 'Credit Enhancement Type',
  stateGuarantee: 'IBank',
  calCap: 'CalCAP SB',
  calCapPortfolio: 'CalCAP Portfolio: 2024',
  loans: 'Loans',
  ineligible: 'Ineligible',
  areYouSureYouWantMarkLoanAsIneligible:
    'Are you sure you want mark loan as ineligible?',
  markAsIneligible: 'Mark as Ineligible',
  loanMarkedAsIneligible: 'Loan marked as ineligible',
  downloadLoanClosureMemo: 'Download Loan Closure Memo',
  searchLoans: 'Search Loans',
  portfolioLoans: 'Loan Portfolio',
  activeLoans: 'Active Loans',
  notifyAccounting: 'Notify Accounting',
  sendNotificationToAccounting: 'Send Notification to Accounting',
  saveToSend: 'Save to send',
  sendNoticeDefaultLackInsurance:
    'Send Notice of Default Due to Lack of Insurance',
  downloadNoticeDefaultLackInsurance:
    'Download Notice of Default Due to Lack of Insurance',
  emailSentAndSavedSuccessfully: 'Email sent and saved successfully',
  fileSavedSuccessfullyErrorSendingEmail:
    'File saved successfully, with error sending the email',
  areYouSureYouWantToSendNoticeDefaultLackInsurance:
    'Are you sure you want to send the Default Notice Lack Insurance?',
  voluntaryCollateralRelease: 'Voluntary Collateral Release',
  dateInformedVoluntaryReturn: 'Date Informed Voluntary Return',
  sendVoluntaryCollateralReleaseLetter:
    'Send Voluntary Release of Collateral Letter',
  downloadVoluntaryCollateralReleaseLetter:
    'Download Voluntary Release of Collateral Letter',
  areYouSureYouWantToSendVoluntaryCollateralReleaseLetter:
    'Are you sure you want to send the Voluntary Release of Collateral Letter?',
  noticeLoanDefault: 'Notice of Loan Default',
  categoryFile: 'Category File(s)',
  uploadedByUser: 'Uploaded by User',
  demandLetter: 'Demand Letter',
  watchList: 'Watch List',
  monthlyPaymentDueDate: 'Monthly Payment Due Date',
  totalPastDueAmount: 'Total Past Due Amount',
  call: 'Call',
  sendNotifications: 'Send Notifications',
  amountInProcess: 'Amount in Process',
  signOff: 'Click here to approve the Demand Letter',
  nsf: 'NSF',
  borrowerProfileData: 'Borrower Profile Data',
  ficoScore: 'FICO Score',
  minFicoScore: 'Min FICO Score',
  maxFicoScore: 'Max FICO Score',
  yearsInBusiness: 'Years in Business',
  minYearsInBusiness: 'Min Years in Business',
  maxYearsInBusiness: 'Max Years in Business',
  monthsInBusiness: 'Months in Business',
  minMonthsInBusiness: 'Min Months in Business',
  maxMonthsInBusiness: 'Max Months in Business',
  downPaymentPercentage: 'Down Payment Percentage',
  minDownPaymentPercentage: 'Min Down Payment Percentage',
  maxDownPaymentPercentage: 'Max Down Payment Percentage',
  totalMonthlyBankDeposits:
    'Total Monthly Bank Deposits (3-month average) at Origination',
  minTotalMonthlyBankDeposits: 'Min Total Monthly Bank Deposits',
  maxTotalMonthlyBankDeposits: 'Max Total Monthly Bank Deposits',
  numberOfPreviousLoans: 'Number of Previous Loans',
  minNumberOfPreviousLoans: 'Min Number of Previous Loans',
  maxNumberOfPreviousLoans: 'Max Number of Previous Loans',
  typeOfBusiness: 'Type of Business Entity',
  loanCharacteristics: 'Loan Characteristics',
  minLoanAmount: 'Min Loan Amount',
  maxLoanAmount: 'Max Loan Amount',
  loanTerm: 'Loan Term (months)',
  minLoanTerm: 'Min Loan Term',
  maxLoanTerm: 'Max Loan Term',
  minInterestRate: 'Min Interest Rate',
  maxInterestRate: 'Max Interest Rate',
  minMonthlyPaymentAmount: 'Min Monthly Payment Amount',
  maxMonthlyPaymentAmount: 'Max Monthly Payment Amount',
  loanToValueRatioAtOrigination: 'Loan to Value Ratio at Origination',
  minLoanToValueRatioAtOrigination: 'Min Loan to Value',
  maxLoanToValueRatioAtOrigination: 'Max Loan to Value',
  originationFeeCharged: 'Origination Fee Charged',
  minOriginationFeeCharged: 'Min Origination Fee Charged',
  maxOriginationFeeCharged: 'Max Origination Fee Charged',
  timeFromApplicationToFunding: 'Time from Application to Funding',
  minTimeFromApplicationToFunding: 'Min Time from Application to Funding',
  maxTimeFromApplicationToFunding: 'Max Time from Application to Funding',
  collateralInformation: 'Collateral Information',
  vehicleType: 'Vehicle Type',
  vehicleAgeAtOrigination: 'Vehicle Year',
  minVehicleAgeAtOrigination: 'Min Vehicle Age',
  maxVehicleAgeAtOrigination: 'Max Vehicle Age',
  vehicleMileageAtOrigination: 'Vehicle Mileage at Origination',
  minVehicleMileageAtOrigination: 'Min Vehicle Mileage',
  maxVehicleMileageAtOrigination: 'Max Vehicle Mileage',
  vehicleManufacturer: 'Vehicle Manufacturer',
  originalPurchasePrice: 'Original Purchase Price',
  minOriginalPurchasePrice: 'Min Original Purchase Price',
  maxOriginalPurchasePrice: 'Max Original Purchase Price',
  typeOfHauling: 'Type of Hauling',
  paymentPerformance: 'Payment Performance',
  numberOfLatePayments: 'Number of Late Payments (lifetime)',
  minNumberOfLatePayments: 'Min Number of Late Payments',
  maxNumberOfLatePayments: 'Max Number of Late Payments',
  averageDaysLatePerPayment: 'Average Days Late per Payment',
  minAverageDaysLatePerPayment: 'Min Average Days Late per Payment',
  maxAverageDaysLatePerPayment: 'Max Average Days Late per Payment',
  numberOfNSF: 'Number of NSF (non-sufficient funds) Instances',
  minNumberOfNSF: 'Min Number of NSF',
  maxNumberOfNSF: 'Max Number of NSF',
  numberOfLoanExtensionsRequested: 'Number of Loan Extensions Requested',
  minNumberOfLoanExtensionsRequested: 'Min Number of Loan Extensions Requested',
  maxNumberOfLoanExtensionsRequested: 'Max Number of Loan Extensions Requested',
  numberOfLoanExtensionsGranted: 'Number of Loan Extensions Granted',
  minNumberOfLoanExtensionsGranted: 'Min Number of Loan Extensions Granted',
  maxNumberOfLoanExtensionsGranted: 'Max Number of Loan Extensions Granted',
  numberOfLoanDeferralsRequested: 'Number of Loan Deferrals Requested',
  minNumberOfLoanDeferralsRequested: 'Min Number of Loan Deferrals Requested',
  maxNumberOfLoanDeferralsRequested: 'Max Number of Loan Deferrals Requested',
  numberOfLoanDeferralsGranted: 'Number of Loan Deferrals Granted',
  minNumberOfLoanDeferralsGranted: 'Min Number of Loan Deferrals Granted',
  maxNumberOfLoanDeferralsGranted: 'Max Number of Loan Deferrals Granted',
  longestConsecutiveStreak: 'Longest Consecutive Streak',
  minLongestConsecutiveStreak: 'Min Longest Consecutive Streak',
  maxLongestConsecutiveStreak: 'Max Longest Consecutive Streak',
  numberOfInsuranceLapses: 'Number of Insurance Lapses',
  minNumberOfInsuranceLapses: 'Min Number of Insurance Lapses',
  maxNumberOfInsuranceLapses: 'Max Number of Insurance Lapses',
  numberOfAchAutoDebitFailures: 'Number of ACH Auto Debit Failures',
  minNumberOfAchAutoDebitFailures: 'Min Number of ACH Auto Debit Failures',
  maxNumberOfAchAutoDebitFailures: 'Max Number of ACH Auto Debit Failures',
  dryVan: 'Dry Van',
  flatbed: 'Flatbed',
  reefer: 'Reefer',
  riskManagement: 'Risk Management',
  createRiskManagement: 'Create Risk Management Filter',
  editRiskManagement: 'Edit Risk Management Filter',
  newRiskManagementFilter: 'New Risk Management Filter',
  riskManagementFilterToDelete: 'Risk Management Filter to Delete',
  areYouSureYouWantToDeleteTheRiskManagementFilter:
    'Are you sure you want to delete this filter?',
  riskManagementFilterSavedOrUpdatedSuccessfully:
    'Risk Management Filter saved or updated successfully',
  riskManagementFilterDeletedSuccessfully:
    'Risk Management Filter deleted successfully',
  riskManagementFilterNoFound: 'Risk Management Filter no found',
  totalMonthlyBankDepositsTable: 'Total Monthly Bank Deposits',
  numberOfNSFTable: 'Number of NSF',
  default: 'Default',
  loanManagementReports: 'Loan Management Reports',
  interestPayment: 'Interest Payment',
  downloadInterestPaymentDocument: 'Download Interest Payment Document',
  sendInterestDocumentToPrincipalContact:
    'Send Interest Document to Principal Contact',
  interestPaymentDocumentSentSuccessfully:
    'Interest payment document sent successfully',
  interestPaymentDocumentSentToAllEmailsSuccessfully:
    'Interest payment document sent to all emails successfully',
  historicalDataTape: 'Historical Data Tape',
  folderLink: 'Link to Folder',
  downloadReport: 'Download report',
  investorPaid: 'Investor Paid',
  datePaid: 'Date Current Balance Paid',
  disbursementDate: 'Disbursement Date',
  minDisbursementDate: 'Min Disbursement Date',
  maxDisbursementDate: 'Max Disbursement Date',
  defaultsChargedOff: 'Defaults/Charged Off',
  minLiquidationAmount: 'Min Liquidation Amount',
  maxLiquidationAmount: 'Max Liquidation Amount',
  numberOfMissedPayments: 'Number of Missed Payments',
  minNumberOfMissedPayments: 'Min Number of Missed Payments',
  maxNumberOfMissedPayments: 'Max Number of Missed Payments',
  minDefaultDate: 'Min Default Date',
  maxDefaultDate: 'Max Default Date',
  dateModified: 'Date Modified',
  portfolioPerformance: 'Portfolio Performance',
  assistant: 'Assistant',
  whatCanIHelpWith: 'What Can I Help With?',
  newChat: 'New Chat',
  useAssistant: 'Use Assistant',
  modifiedBy: 'Modified By',
  ai: 'AI',
  gemini: 'Gemini',
  dataIsEmpty: 'Data is Empty',
  addFile: 'Add File(s)',
  askSomething: 'Ask Something',
  approveNoticeLoanDefault: 'Click here to approve Default Notice',
  dateReceivedGreaterDemandLetter:
    'Date Received must be greater than the Date Demand Letter Submitted',
  averageLoanTerm: 'Average Loan Term',
  averageDownPayment: 'Average Down Payment',
  minusRepairsDone: 'Minus Repairs Done',
  insuranceNotes: 'Notes',
  claims: 'Claims',
  newInsuranceClaim: 'New Insurance Claim',
  claimNumber: 'Claim Number',
  filedDate: 'Filed Date',
  insuranceCarrier: 'Insurance Carrier',
  pending: 'Pending',
  lastUpdateDate: 'Last Updated',
  areYouSureDeleteThisClaim: 'Are you sure you want to delete this claim?',
  loanClaimNotFound: 'Claim not found',
  editInsuranceClaim: 'Edit Insurance Claim',
  errorSavingInformation: 'Error saving information',
  noClaims: 'No claim(s) registered',
  completedDate: 'Completed Date',
  daysPending: 'Days Pending',
  filedDateRange: 'Filed Date Range',
  amountRange: 'Amount Range',
  daysPendingRange: 'Days Pending Range',
  minDaysPending: 'Min Days Pending',
  maxDaysPending: 'Max Days Pending',
  totalAmountPendingClaims: 'Total Amount of Pending Claims',
  totalAmountActiveClaims: 'Total Amount of Active Claims',
  totalPendingClaims: 'Pending Claims',
  totalActiveClaims: 'Active Claims',
  investorAddressFirstPart: 'Address First Part',
  investorAddressSecondPart: 'Address Second Part',
  carrier: 'Carriers',
  legalNameOrDBAName: 'Legal Name or DBA Name',
  dotNumber: 'DOT Number',
  docketNumber: 'Docket Number',
  allowedToOperate: 'Allowed to Operate',
  bipdInsuranceOnFile: 'Insurance on File',
  bipdInsuranceRequired: 'Insurance Required',
  bipdRequiredAmount: 'Required Amount',
  commonAuthorityStatus: 'Common Authority Status',
  contractAuthorityStatus: 'Contract Authority Status',
  crashTotal: 'Crash Total',
  dbaName: 'DBA Name',
  driverInsp: 'Driver Insp.',
  legalName: 'Legal Name',
  phyCity: 'Phy City',
  phyCountry: 'Phy Country',
  phyState: 'Phy State',
  phyStreet: 'Phy Street',
  phyZipcode: 'Phy Zipcode',
  safetyRating: 'Safety Rating',
  carrierOperationCode: 'Code',
  carrierOperationDesc: 'Description',
  carrierOperation: 'Carrier Operation',
  bipd: 'BIPD',
  consolidatedReport: 'Consolidated',
  paymentsReport: 'Payments',
  report: 'Report',
  currentBalanceOwed: 'Current Balance Owed',
  numberOfDaysLate: 'Number of Days Late',
  minNumberOfDaysLate: 'Min Number of Days Late',
  maxNumberOfDaysLate: 'Max Number of Days Late',
  delinquentLoans: 'Delinquent Loans',
  information: 'Information',
  certificates: 'Certificates',
  loanAgreements: 'Loan Agreements',
  noPolicies: 'No policies registered',
  addInsurancePolicy: 'Add Insurance Policy',
  addedSuccessfully: 'Added successfully',
  deleteInsurancePolicy: 'Delete Insurance Policy',
  noCertificates: 'No certificates registered',
  addInsuranceCertificate: 'Add Insurance Certificate',
  noAgreements: 'No agreements registered',
  addLoanAgreement: 'Add Loan Agreement',
  noExistInsurancePolicies: 'No exist Insurance Policy(ies)',
  insurancePoliciesLoadedSuccessfully:
    'Insurance Policy(ies) loaded successfully',
  noExistInsurancePolicy: 'No exist Insurance Policy',
  insurancePolicyAttachmentNotExist: 'Insurance Policy Attachment not exist',
  noExistInsuranceCertificates: 'No exist Insurance Certificate(s)',
  insuranceCertificatesLoadedSuccessfully:
    'Insurance Certificate(s) loaded successfully',
  noExistInsuranceCertificate: 'No exist Insurance Certificate',
  insuranceCertificateAttachmentNotExist:
    'Insurance Certificate Attachment not exist',
  noExistInsuranceAgreements: 'No exist Insurance Agreement(s)',
  insuranceAgreementsLoadedSuccessfully:
    'Insurance Agreement(s) loaded successfully',
  noExistInsuranceAgreement: 'No exist Insurance Agreement',
  insuranceAgreementAttachmentNotExist:
    'Insurance Agreement Attachment not exist',
  vehicleInformation: 'Vehicle Information',
  statedValue: 'Stated Value',
  creditEnhancement: 'Credit Enhancement',
  loanPerformanceDashboard: 'Loan Performance Dashboard',
  moreThanOneFile: 'There is more than one such file, please review',
  editDateCurrentBalancePaid: 'Edit Date Current Balance Paid',
  datePaidCannotBeBeforeNoticeLoanDefault:
    'Date Current Balance Paid cannot be before the Date of Default Notice',
  docusignDocuments: 'Docusign Documents',
  noDocusignDocuments: 'No Docusign document(s) registered',
  addDocusignDocument: 'Add Docusign Document',
  docusignDocumentAddedSuccessfully: 'Docusign document added successfully',
  showActiveLoans: 'Show Active Loans',
  defaultRateByYearsInBusiness: 'Default Rate by Years in Business',
  lessThanTwoYears: 'Less than 2 years',
  greaterThanOrEqualToTwoYears: 'Greater than or equal to 2 years',
  paymentHistoryByHaulType: 'Payment History by Haul Type',
  outOfCalifornia: 'Out of California',
  inCalifornia: 'In California',
  both: 'Both',
  from1To29DaysLate: 'from 1 to 29 days late',
  from30To59DaysLate: 'from 30 to 59 days late',
  from60OrMoreDaysLate: 'from 60 or more days late',
  assignmentLenderInterestSentToAllEmailsSuccessfully:
    'Assignment Lender Interest sent to all emails successfully',
  downloadAssignmentLenderInterest: 'Download Assignment Lender Interest',
  sendSignedAssignmentLenderInterest: 'Send Signed Assignment Lender Interest',
  sentAssignmentLenderInterest: 'Assignment Lender Interest was sent',
  assignmentLenderInterest: 'Assignment Lender Interest',
  defaultRateByDownPaymentPercent: 'Default Rate (by Down Payment)',
  twentyOrMoreDownPayment: '20% or More Down',
  lessThanTwentyDownPayment: 'Less than 20% Down',
  defaultRateByLoanTerm: 'Default Rate (by Loan Term)',
  fortyEightMonthsOrLess: '48 Months or Less',
  sixtyOrMoreMonths: '60 or More Months',
  defaultRateByTruckAge: 'Default Rate (by Truck Age)',
  threeYearsOrLess: '3 Years or Less',
  moreThanThereYears: 'More than 3 Years',
  northern: 'Northern',
  southern: 'Southern',
  central: 'Central',
  loansByRegion: 'Loans by Region',
  emailAlerts: 'Email Alerts',
  microsoftGraphAPI: 'Microsoft Graph',
  gpsDeviceCode: 'GPS Device Code',
  noEmailsAlerts: 'No email alert(s) registered',
  lastNotificationDate: 'Last Notification Date',
  sixtyDays: '60 Days',
  downloadInsuranceFinancingReport: 'Download Insurance Financing Report',
  receivedDate: 'Received Date',
  notificationFrom: 'Notification From',
  showEmailContent: 'Show Email Content',
  emailAlertNotFound: 'Email Alert not found',
  fileDescription: 'File Description',
  downloadNoticeClaimsDepartment: 'Download Notice to Claims Department',
  noticeClaimDepartmentSentToAllEmailsSuccessfully:
    'Notice to Claims Department sent to all emails successfully',
  sendNoticeClaimsDepartment: 'Send Notice to Claims Department',
  productVehicleNotFound: 'Product Vehicle not found',
  soldTo: 'Sold to',
  paidOffLetter: 'Paid Off Letter',
  dateOfNoticePaidOffLetter: 'Date of Notice Paid Off Letter',
  downloadPaidOffLetter: 'Download Paid Off Letter',
  sendPaidOffLetter: 'Send Paid Off Letter',
  paidOffLetterNoticeSentToAllEmailsSuccessfully:
    'Paid Off Letter notice sent to all emails successfully',
  delinquencyNoticeReport: 'Delinquency Notices',
  delinquencyNoticeDocument: 'Delinquency Notice Document',
  loanPaidOffFilesNotExist: 'Paid off files do not exist',
  loanPaidOffFileDeletedSuccessfully: 'Paid off file deleted successfully',
  amountRemainingCompletePayment: 'Amount Remaining to Complete a Payment',
  noExistNotificationLoanPaymentExtensionAddedSuccessfully:
    'Notification no found. Payment Extension added successfully',
  paymentExtensionAddedAndEmailSuccessfully:
    'Payment Extension added and email sent successfully',
  errorSendingEmailPaymentExtensionAddedSuccessfully:
    'Error sending email. Payment Extension added successfully',
  note: 'Note',
  sendInsuranceClaim: 'Send Completed Claim Letter to Borrower',
  downloadInsuranceClaim: 'Download Completed Claim Letter',
  claimNotFound: 'Claim not found',
  insuranceClaimSentToAllEmailsSuccessfully:
    'Insurance Claim sent to all emails successfully',
  activeClaim: 'Active Claim',
  valuation: 'Valuation',
  blackBookValue: 'Black Book Value',
  averageValue: 'Average Value',
  outstandingPrincipalBalance: 'Outstanding Principal Balance',
  valuationVehicleInformation: 'Valuation Vehicle Information',
  originalEquipmentValue: 'Original Equipment Value',
  collateralValuationReport: 'Collateral Valuation Report',
  updateDate: 'Last Updated on',
  titleDocuments: 'Title Document(s)',
  viewDocuments: 'View Document(s)',
  eqLoansPortfolio: 'EQ Loans Portfolio',
  principalPayments: 'Principal Payments',
  automaticPaymentExtension: 'Automatic Payment Extension',
  totalPrincipalPaid: 'Total Principal Paid',
  totalInterestPaid: 'Total Interest Paid',
  totalFeesPaid: 'Total Fees Paid',
  chargedOffAmount: 'Charged Off Amount',
  paymentExtensions: 'Payment Extensions',
  deferralDetails: 'Deferral Details',
  preApprovedDeferral: 'Pre-approved Deferral',
  deferralApproval: 'Approval',
  skip: 'Skip',
  finish: 'Finish',
  reset: 'Reset',
  stepsCompleted: 'All steps for deferral completed',
  paymentDeferrals: 'Payment Deferrals',
  reschedule: 'Restructure',
  stepNotSkippable: 'This step is not skippable',
  paymentDeferralNotExist: 'Payment Deferral does not exist',
  unexpectedErrorSendingEmailStepSavedSuccessfully:
    'Unexpected error sending email. Step saved successfully.',
  rescheduleSavedSuccessfully: 'Reschedule saved successfully',
  stepCannotBeSkipped: "You can't skip a step that isn't optional",
  categorizedDocuments: 'Categorized Documents',
  documents: 'Documents',
  customReport: 'Custom Report',
  monthlyStatements: 'Monthly Statements',
  liquidatedCollateralAmountIsLessThanZero:
    'The Liquidated Collateral Amount is less than zero! Please review the entered amounts.',
  approvedDemandLetter: 'Demand Letter Approved',
  approvalRevocationRequired:
    'If you need to make changes and do not have permission to revoke approval, you must request it from the accounting department.',
  requestRevokeApproval: 'Request to Revoke Approval',
  revokeApproval: 'Revoke Approval',
  areYouSureYouWantToRevokeApproval:
    'Are you sure you want to revoke the approval of the',
  demandLetterApprovalRevokedSuccessfully:
    'Demand Letter approval revoked successfully',
  demandLetterSentToEmails: 'Approved Demand Letter Sent to Email(s)',
  requestRevokeApprovalSent: 'Request to Revoke Approval was Sent',
  requestSentSuccessfully: 'Request sent successfully',
  unexpectedErrorSendingRequest: 'Unexpected error sending request',
  userNotHavePermission: 'User does not have permission to approve',
  approvalRevocationAndEmailSentSuccessfully:
    'Approval revocation and notificación sent successfully',
  downPaymentPercentageHdt: 'Down Payment %',
  closingCostPercentage: 'Closing Costs %',
  simulation: 'Simulation',
  letters: 'Letters',
  sendForSignature: 'Send for Signature',
  deferralOfPaymentLetter: 'Deferral of Payment.pdf',
  amendmentToPromissoryNoteReDeferralsLetter:
    'Amendment to Promissory Note Re Deferrals.pdf',
  letterNotExist: 'Letter does not exist',
  paymentPlanSimulationNotFound: 'Payment Plan Simulation not found',
  areYouSureThisEmailContactNotification:
    'Are you sure you want to send the notification to this email?',
  sendForSignatureSuccessfully: 'Sent for signature successfully',
  simulationSavedSuccessfully: 'Simulation step saved successfully',
  lettersavedSuccessfully: 'Letters step saved successfully',
  existMoreThanOneNoticeLoanDefault:
    'There is more than one Notice of Loan Default',
  companyReserve: 'Company Reserve',
  endingPrincipalBalanceDifferentOutstandingPrincipalBalance:
    'Ending Principal Balance is different from Outstanding Principal Balance',
  loanToBeChargedOff: 'Loan to be Charged Off',
  supplementaryTextForDemandLetter: 'Supplementary text for the Demand Letter',
  paragraphFourOfDemandLetter: 'Paragraph Four of the Demand Letter',
  currentValue: 'Current Value',
  avgAmount: 'Avg Amount',
  avgRate: 'Avg Rate',
  avgTerm: 'Avg Term',
  avgDownPmt: 'Avg Down Pmt',
  loansSold: 'Loans Sold',
  valueSold: 'Value Sold',
  portfolioPerformanceSegments: 'Portfolio Performance Segments',
  totalPortfolioValue: 'Total Portfolio Value',
  totalActiveLoans: 'Total Active Loans',
  averageLtvRatio: 'Average LTV Ratio',
  averageLtvRatioNoClosing: 'Average LTV Ratio',
  noClosingCosts: 'No Closing Costs',
  totalLoansSold: 'Total Loans Sold',
  ofDefaults: 'of Defaults',
  noticeLoanDefaultApproved: 'Notice of Loan Default Approved',
  noticeLoanDefaultSentToEmails:
    'Approved Notice of Loan Default Sent to Email(s)',
  plaidTransactions: 'Plaid Transactions',
  valueIsNullOrEmpty: 'Value is null or empty',
  connectBankViaPlaid: 'Connect Bank (via Plaid)',
  getTransactionsFromBank: 'Get transactions from Bank',
  merchantName: 'Merchant Name',
  paymentChannel: 'Payment Channel',
  financeCategory: 'Finance Category',
  plaidConnectedSuccessfully: 'Plaid connected successfully',
  otherVins: 'Other VINs',
  addOtherVin: 'Add VIN',
  editOtherVin: 'Edit VIN',
  deleteOtherVin: 'Delete VIN',
  noOtherVins: 'No other VINs registered',
  otherVinNotFound: 'Other VIN not found',
  searchByDisbursementDate: 'Search by Disbursement Date',
  searchBySaleDate: 'Search by Sale Date',
  nameOfTheInsured: 'Name of the Insured',
  seekCourtJudgement: 'Seek Court Judgement',
  downloadSeekCourtJudgement: 'Download Seek Court Judgement PDF',
  licenseClass: 'License Class',
  licenseNonDomCdl: 'Non-Dom CDL',
  suspendedFtb: 'Suspended - FTB',
  valid: 'Valid',
  cdlJurisdiction: 'CDL Jurisdiction',
  driverLicenses: 'Driver Licenses',
  driverName: 'Driver',
  downloadPoliciesReport: 'Download Policies Report',
  downloadDriverLicenseReport: 'Download Driver License Report',
  searchByExpirationDate: 'Search by Expiration Date',
  dateReceivedFromState: 'Date Received from State',
  searchByCreationDate: 'Search by Creation Date',
  searchByDefaultedDate: 'Search by Defaulted Date',
  searchByClearedDate: 'Search by Cleared Date',
  searchByReceivedDate: 'Search by Received Date',
  searchByStatusChangeDate: 'Search by Status Change Date',
  searchByDueDate: 'Search by Due Date',
  monthlyPaymentDay: 'Monthly Payment Day',
  citizenshipStatus: 'Citizenship Status',
  visaWorkPermitExpirationDate: 'Visa/Work Permit Expiration Date',
  stateGuaranteeDetails: 'State Guarantee Details',
  sendToEmails: 'Send to Email(s)',
  initialInvestmentAndPayments:
    'In event of loan default, this value represents the Initial Investment (including Premium) and subtracts all payments made to the investor through the date of the default',
  referralFee: 'Referral Fee',
  paymentDueDay: 'Payment Due Day',
  totalLoansOriginated: 'Total Loans Originated',
  totalNumberOfLoansOriginated: 'Total Number of Loans Originated',
  totalValueOfLoansFunded: 'Loans Funded Value',
  collateralReports: 'Collateral Reports',
  vehicles: 'Vehicles',
  areYouSureSendInvitationToThisBorrower:
    'Are you sure you want to send an invitation to this borrower to access the Borrower Portal?',
  sendingInvitationToBorrowerPortal: 'Sending invitation to Borrower Portal',
  identificationNumberNotFound: 'Identification number not found',
  emailAlreadyInUse: 'Email already in use',
  invitationSentSuccessfully: 'Invitation sent successfully',
  enterNewBankAccountInfo:
    'Enter your new bank account information below to make a payment.',
  bankAccountInfoNote:
    'The bank account and routing number you enter will be securely stored and used for all future automatic payments unless you update your payment information again.',
  loanChangedAndNotificationSent:
    'Loan changed and notification sent successfully',
  loanChangedAndNotificationFailed:
    'Loan changed and notification failed to send',
  downloadPaymentDefaultNotice: 'Download Payment Default Notice',
  sendPaymentDefaultNotice: 'Send Payment Default Notice',
  areYouSureYouWantToSendPaymentDefaultNotice:
    'Are you sure you want to send the Payment Default Notice?',
  enterVin: 'Enter VIN',
  enterBorrowerName: 'Enter Borrower Name',
  enterMake: 'Enter Make',
  enterModel: 'Enter Model',
  enterYear: 'Enter Year',
  lossPayeeEndorsement: 'Loss Payee Endorsement',
  lossPayablesEndorsement: 'Loss Payables Endorsement',
  policyDeclarationPage: 'Policy Declaration Page',
  borrowersAndcontacts: 'Borrowers and Contacts',
  contact: 'Contact',
  contactName: 'Contact Name',
  enterLoanCode: 'Enter Loan Code',
  enterContactName: 'Enter Contact Name',
  enterPhone: 'Enter Phone',
  enterEmail: 'Enter Email',
  enterAddress: 'Enter Address',
  paymentsMadeToDate: 'Payments Made to Date',
  totalPaymentsMade: 'Total Payments Made',
  showNote: 'Show Note',
  attachmentsAdded: 'Attachments Added',
  noAttachments: 'No Attachments',
  editInsuranceNote: 'Edit Insurance Note',
  ok: 'Ok',
  showAllNotes: 'Show All Notes',
  lastNote: 'Last Note',
  loanSaleDetailsNotExist: 'Loan Sale Details not exist',
  mileageAtOrigination: 'Mileage at Origination',
  paymentReportSentToAllEmailsSuccessfully:
    'Payment Report sent to all emails successfully',
  paymentStatus: 'Payment Status',
  paidOff: 'Paid Off',
  dateOfNoticeLoanPaidOff: 'Date of Paid Off Notice'
};

export const loanDetailsEs = {
  'A transaction still exists on this loan':
    'Aún existe una transacción en este préstamo',
  transactionCompletedNotificationDidNotSend:
    'Transaccion completada. Notificación no enviada.',
  accountId: 'ID de cuenta',
  accountToken: 'Token de cuenta',
  accountNumber: 'Número de Cuenta',
  activity: 'Actividad',
  Activity: 'Actividad',
  activityDate: 'Fecha de actividad',
  agreementDate: 'Fecha de acuerdo',
  alreadyPaid: 'Ya pagó',
  areYouSureYouWantMarkLoanForSale:
    '¿Está seguro de marcar préstamo para venta?',
  autoPayment: 'Pago Automático',
  autoPaymentParameters: 'Parametrización de Pagos Automaticos',
  availableForSale: 'Disponible para venta',
  bankAccount: 'Cuenta bancaria',
  bankName: 'Nombre del Banco',
  'Change rate': 'Cambiar tasa',
  chargesAddedValueLoan: 'Cargos agregados al valor del prestamo',
  chargesDeductedDisbursement: 'Cargos deducidos al desembolso',
  changeLoanStatusDescription: ' Seleccione Estado de Destino',
  changeStatus: 'Cambiar Estado',
  'Charge amount': 'Valor de cargos',
  company: 'Empresa',
  Complete: 'Completar',
  currentStatus: 'Estado Actual',
  customerDetails: 'Detalles de cliente',
  'Delete loan installment': 'Borrar cuota de préstamo',
  destinationState: 'Estado de Destino',
  disbAmountLabel: 'Valor de desembolso',
  disbAmtExceedsLoanAmt: 'El valor a desembolsar excede el valor del préstamo.',
  generateDisbursementFile: 'Generar archivo de desembolsos',
  disburse: 'Desembolsar',
  disbursedAmount: 'Monto desembolsado',
  disburseLabelBtn: 'Desembolsar',
  disburseLoan: 'Desembolsar Préstamo',
  'Disbursement transaction made.': 'Operación de desembolso realizada.',
  dontAnswer: 'Sin respuesta',
  download: 'Descargar',
  downloadDisbFileSubTtl:
    'Seleccione la cuenta y la fecha para generar el archivo de desembolsos',
  downloadDisbFileTtl: 'Descargar archivo de desembolsos',
  loanEffectiveDate: 'Fecha efectiva',
  loanEffectiveDateCapital: 'Fecha Vigencia',
  paymentDueDate: 'Vencido',
  enterCustomerNameIdentification:
    'Ingrese nombre o número de cédula del cliente',
  enterProductNameId: 'Ingrese número o nombre del producto',
  entity: 'Entidad',
  EquatedInstallments: 'Cuotas iguales',
  evidences: 'Evidencias',
  'Existe un préstamo activo para la solicitud.':
    'Existe un préstamo activo para la solicitud.',
  fileDeleted: 'Archivo eliminado',
  filesAreRequired: 'Los archivos son requeridos',
  from: 'de',
  getLoanInfoFailed: 'Información del préstamo no encontrada',
  'Grace period': 'Periodo de gracia',
  'Grace period for': 'Periodo de gracia para',
  'Grace periods': 'Periodos de gracia',
  'Grace periods apply for': 'Periodos de gracia aplican para',
  'Has grace period?': '¿Tiene periodo de gracia?',
  inactive: 'Inactivo',
  incorrectNumber: 'Número incorrecto',
  'Installment amount': 'Valor de cuota',
  totalDueAmount: 'Valor total adeudado',
  'Installment of': 'Cuota del',
  'Installment type': 'Tipo de cuota',
  'Interest amount': 'Valor de intereses',
  interestRate: 'Tasa de interés',
  'La fecha inicial de pago no puede ser menor a la fecha de la transacción. ':
    'La fecha inicial de pago no puede ser menor a la fecha de la transacción.',
  'La solicitud debe estar en estado Iniciada para poder ser borrada. ':
    'La solicitud debe estar en estado Iniciada para poder ser borrada.',
  lastTranDisbError:
    'La fecha del desembolso no puede ser menor a la fecha de la última transacción.',
  loan: 'Préstamo',
  Loan: 'Préstamo',
  'Loan details': 'Detalles de préstamo',
  'Loan Rescheduling': 'Re-estructuración de préstamo',
  loanCode: 'Código del préstamo',
  loanCodeCapital: 'Código Préstamo',
  loanAmount: 'Monto del préstamo',
  prLoanAmount: 'Monto del Préstamo',
  loanAvailableForSale: 'Préstamo disponible para venta',
  loanChanged: 'Se ha cambiado estado del Préstamo',
  loanChangeNoAllowed: 'Cambio de estado no es permitido',
  loanDetails: 'Detalles de préstamo',
  loanInstallment: 'Plazo del préstamo',
  loanManagement: 'Administrar prestamo',
  loanNoFound: 'Préstamo no encontrado',
  loanRequest: 'Solicitud de préstamo',
  loanRequestValidations: 'Validaciones de solicitudes de préstamo',
  paymentMethods: ' Métodos de pago',
  loanlist: 'Portafolio de préstamos',
  loansId: 'ID',
  loanToFactorDetails: 'Detalles del préstamo a la fábrica',
  loanTransaction: 'Transacción de préstamo',
  loanTransactions: 'Transacciones de Préstamo',
  loanValidations: 'Validaciones del préstamo',
  loanWithNoRepaymentSchedule: 'Préstamo sin calendario de amortización',
  markForSale: 'Marcar para venta',
  noAllowedTransactions:
    'Esta transacción no está permitida para préstamos con este estado',
  noAllowedTransactionsMenu: 'Transacciones no permitidas',
  noContentFile: 'No se encontraron archivos de desembolsos.',
  noInvestorForLoan:
    'No se encontraron inversionistas para asignar al préstamo.',
  noMultipleDisbAllowed:
    'No se permiten varios desembolsos para el producto de préstamo seleccionado.',
  NonEquatedInstallments: 'Cuotas no iguales',
  notAbleToPay: 'Sin capacidad de pago',
  notValidated: 'No validado',
  numberInstallmentsMustGreaterEqualOne:
    'El número de cuotas debe ser mayor o igual a 1',
  numberInstallmentsExceedMaximumDate:
    'El numero de cuotas superan la fecha maxima 2100-01-01',
  'Number of installments': 'Número de cuotas',
  numberOfInstallments: 'Número de cuotas',
  observations: 'Observaciones',
  'Overdue date': 'Fecha de vencimiento',
  Overview: 'Vista General',
  pay: 'Pagar',
  Pay: 'Pagar',
  'Paid amount': 'Valor pagado',
  paidAmount: 'Valor pagado',
  totalPaidAmount: 'Valor total pagado',
  'Paid interest amount': 'Valor pagado de intereses',
  paidInterestAmount: 'Valor pagado de intereses',
  'Paid penal amount': 'Valor pagado de mora',
  paidPenalAmount: 'Valor pagado de mora',
  'Paid principal amount': 'Valor pagado de capital',
  paidPrincipalAmount: 'Valor pagado de capital',
  paidChargeAmount: 'Valor pagado de cargos',
  'Payment start date': 'Fecha de inicio de pago',
  paymentStartDate: 'Fecha de inicio de pago',
  paymentMethodDisburse: 'Medio de Desembolso',
  paymentPlan: 'Plan de pagos',
  paymentPlanRestructured: 'Plan de pagos reestructurado',
  'Penal amount': 'Valor de mora',
  penalRate: 'Tasa de mora',
  pendingAmount: 'Monto pendiente',
  outstandingPrincipal: 'Pendiente',
  pendingPrincipal: 'Capital pendiente',
  outstandingBalance: 'Saldo pendiente',
  pendingLoanInstallmentsExist:
    'Hay cuotas pendientes con fecha anterior a la fecha del desembolso.',
  'Principal amount': 'Valor capital',
  productType: 'Tipo de producto',
  pymtLessFromDateError:
    'La fecha de inicio de pago no puede ser menor a la fecha de inicio de re-estructuración.',
  pymtStartDateLabel: 'Fecha de inicio de pago',
  insurancePaymentDate: 'Fecha de pago del seguro',
  insuranceExpirationDate: 'Fecha de vencimiento del seguro',
  pymtStartDateNotLessThanDisbDate:
    'La fecha de inicio de pago no puede ser anterior a la fecha de desembolso.',
  'Raised?': '¿Generada?',
  'Re-schedule': 'Reestructurar',
  'Record deleted successfully': 'Registro eliminado correctamente',
  registerPaymentReceived: 'Registrar pago',
  reluctantToPay: 'Renuente al pago',
  Reschedule: 'Re-estructurar',
  'Reschedule from date': 'Re-estructurar desde',
  rescheduleFromDate: 'Re-estructurar desde',
  'Rescheduling parameters': 'Parámetros de re-estructuración',
  reschedulingParametersr: 'Parámetros de re-estructuración',
  'Rescheduling successful message':
    'La re-estructuración del plan de pagos del préstamo ha sido completada exitosamente.',
  reverseLblBtn: 'Revertir',
  reverseTransaction: 'Revertir Transacción',
  reversionDoneCorrectly: 'Reversión realizada correctamente.',
  reviewValidationsIncompleteValidations:
    'Las validaciones son requeridas antes de desembolsar el préstamo',
  routingNumber: 'Número de Ruta',
  'Start date': 'Fecha inicial',
  Tenor: 'Plazo',
  to: 'a',
  tranDateLabel: 'Fecha de transacción',
  transactionCompleted: 'Transacción completada',
  transactionSuccessful: 'Transacción exitosa',
  undefined: 'Sin definir',
  validated: 'Validado',
  'View loan': 'Ver préstamo',
  waived: 'desistido',
  Waived: 'Desistido',
  writeAShortReverseTran:
    'Escriba una breve descripción sobre porqué se está revirtiendo esta transacción.',
  'You are all done!': '¡Ya está completado!',
  successfullyDisbursed: 'Desembolsado exitosamente.',
  successfullyDisbursedTasksWithoutUserAssignment:
    'Desembolsado exitosamente. Tareas creadas sin usuario asignado',
  successfullyDisbursedNotificationNotSent:
    'Desembolsado exitosamente. Notificación no enviada.',
  successfullyDisbursedNotificationNotSentTasksWithoutUserAssignment:
    'Desembolsado exitosamente. Notificación no enviada. Tareas creadas sin usuario asignado',
  debtCollectionActivityAdded:
    'Gestión de cobro de deuda agregada correctamente.',
  debtCollectionActivitiesDontLoaded:
    'No fue posible consultar la información de gestión de cobro.',
  inAnotherDisbursementFile:
    'Los prestamos ya fueron generados en otro archivo.',
  someLoansAlreadyHaveDisbursementFilesAssociated:
    'Algunos prestamos ya tiene archivos de desembolso asociado.',
  historicalPaymentPlan: 'Histórico plan de pago ',
  currentPaymentPlan: 'Plan de pagos actual',
  disbursementFileIsNotAvailablePerBank:
    'El archivo de desembolso no está disponible para la cuenta del Banco seleccionado',
  daysPastDue: 'Días de mora',
  transactionCompletedNotificationSent:
    'Transacción completada notificación enviada',
  paymentStarDateRestructuringDate:
    'La fecha de inicio de pago no puede ser inferior a la fecha de re-estructuración.',
  restructuringDateCannotToday:
    'La fecha de reestructuración no puede ser mayor a la de hoy.',
  unpaidInstallmentsRestructuring:
    'No pueden haber cuotas sin pagar al momento de la reestructuración, elimina la cuota generada e inténtalo de nuevo.',
  installmentsPaymentStartDate:
    'No pueden haber cuotas con fecha superior a la fecha de inicio de pago, elimina la cuota generada e inténtalo de nuevo.',
  installmentsGeneratedWithRestructuringDate:
    'No pueden haber cuotas generadas con fecha superior a la fecha de reestructuración, elimina la cuota generada e inténtalo de nuevo.',
  noGracePeriods: 'No se permiten periodos de gracia para este producto',
  maximunNumberRestructurings:
    'No puede exceder el número máximo de reestructuraciones para el producto',
  exceedDaysRestructuring:
    'El plazo de la reestructuración no puede superar los días parametrizados.',
  gracePeriodValuesnotValid: 'Los valores de periodo de gracia no son válidos.',
  confirmPayment: 'Confirmación de Pago',
  areYouSureYouWantToInitiateACHPayment:
    '¿Está seguro que desea iniciar un pago usando ACHQ para este préstamo?',
  thereIsTransactionInPendingStatus: 'Hay una transacción en estado pendiente',
  nextPaymentDate: 'Fecha próximo pago',
  installmentAmount: 'Monto próximo pago',
  externalCode: 'Código del préstamo',
  installmentDate: 'Fecha de cuota',
  payDate: 'Fecha de pago',
  payOffInfo: 'Información de liquidación',
  payOff: 'Liquidación',
  currentPayment: 'Actual',
  day: 'Día',
  paymentDate: 'Fecha de pago',
  dailyChange: 'Cambio diario',
  sendEmailTo: 'Enviar correo a',
  principalContactEmail: 'Email de contacto principal',
  emailContacts: 'Correo de contacto(s)',
  addEmailContacts: 'Añadir correo de contactos',
  addEmailToSendDocument: 'Agregar correos electrónicos para enviar documento',
  addedEmails: 'Correos agregados',
  addEmail: 'Agregar email',
  sendDocument: 'Enviar documento(s)',
  payOffNotGenerated: 'Liquidación no generada',
  notExistEmailForThisContact: 'No existe email para este contacto',
  unexpectedErrorSendingEmail: 'Error inesperado al enviar correo electrónico',
  payOffSentSuccessfully: 'Liquidación enviada con éxito',
  payOffSentToAllEmailsSuccessfully:
    'Liquidación enviada a todos los correos electrónicos con éxito',
  prepaymentPenalty: 'Cobro por pago anticipado',
  totalAmount: 'Valor total',
  sendStatement: 'Enviar estado de cuenta',
  doesNotExistInstallmentsForThisLoan: 'No existen cuotas para este préstamo',
  noCompleteDataForLoanStatement:
    'No estan completos los datos para generar el estado del préstamo',
  statementSentToAllEmailsSuccessfully:
    'Declaración enviada a todos los correos electrónicos correctamente',
  statementSentSuccessfully: 'Estado de cuenta enviado correctamente',
  validationDisbursWithChargeDiscount:
    'El valor del desembolso no puede ser menor al monto del préstamo ya que el producto cuenta con cargos que se desembolsarán al monto del préstamo.',
  quotaValues: 'Valor adeudado de la cuota',
  paidQuotaValues: 'Valor pagado de la cuota',
  transactions: 'Transacciones',
  paymentMethod: 'Método de pago',
  paymentMethodCapital: 'Método de pago',
  dailyReport: 'Informe Diario',
  weeklyReport: 'Informe Semanal',
  payments: 'Pagos',
  general: 'General',
  delinquentSince: 'En mora desde',
  amountToBePaid: 'Valor a pagar',
  delinquency: 'Morosos',
  delinquencyStatus: 'Estado de morosidad',
  delinquencyReport: 'Reporte de morocidad',
  delinquencyReports: 'Reportes de morocidad',
  paymentProcessing: 'Procesamiento de pago',
  extensionActive: 'Extensiones',
  loansChargedOff: 'Castigados',
  loansDeferral: 'Aplazados',
  noExistDelinquencyStatus: 'No existe este reporte de mora',
  noTransactionInformation: 'No hay información de transacciones',
  AUpdateDate: 'Fecha de aprobación',
  PUpdateDate: 'Fecha de inicio',
  RUpdateDate: 'Fecha de rechazado',
  installmentPeriod: 'Período de pago',
  previousPrincipalBalance: 'Saldo de capital anterior',
  currentPrincipalBalance: 'Saldo de capital actual',
  dueDateCapital: 'Fecha de Vencimiento',
  dailyPayments: 'Pagos Diarios',
  of: 'de',
  show: 'Detalles',
  notes: 'Notas',
  addNotes: 'Agregar notas',
  subject: 'Asunto',
  description: 'Descripción',
  noNotes: 'No se encuentran notas registradas',
  noStatements: 'No se encuentran estados registrados',
  loanNoteAddedSuccessfully: 'Nota agregada con éxito',
  noExistLoanNotes: 'No existen notas',
  noteAttachmentNotExist: 'No existe este archivo',
  loanReports: 'Reportes del préstamo',
  loanTerms: 'Condiciones del préstamo',
  loanParticipation: 'Participación en el préstamo',
  stateGuaranteeReport: 'Garantía del Estado',
  borrower: 'Prestatario',
  loanStatus: 'Estado del préstamo',
  chargedOff: 'Castigado',
  chargedOffInformation: 'Información Préstamo Castigado',
  loanNumber: 'Número de préstamo',
  borrowerName: 'Nombre del prestatario',
  firstPaymentDate: 'Fecha del primer pago',
  monthlyPaymentAmount: 'valor pago mensual',
  attachmentDeletedSuccessfully: 'Archivo adjunto eliminado correctamente',
  deleteAttachment: 'Borrar archivo adjunto',
  loanNoteDeletedSuccessfully: 'Nota de préstamo eliminada con éxito',
  loanNoteUpdatedSuccessfully: 'Nota de préstamo actualizada correctamente',
  loanNotesLoadedSuccessfully: 'Nota de préstamo cargada con éxito',
  noExistAttachment: 'No existe adjunto',
  startTyping: 'Empezar a escribir',
  deleteNote: 'Borrar nota',
  priorPrincipalBalance: 'Saldo Anterior',
  principalAmount: 'Principal',
  interestAmount: 'Interés',
  penaltyFees: 'Penalización',
  totalPaid: 'Total Pagado',
  paymentReport: 'Informe de Pago',
  showPaymentReport: 'Ver informe de pago',
  reportSentToAllEmailsSuccessfully:
    'Reporte enviado a todos los correos electrónicos',
  reportNotGenerated: 'Informe de pago no generado',
  paymentReportSentSuccessfully: 'Informe de pago enviado correctamente',
  sendPaymentReport: 'Enviar reporte de pagos',
  paymentExecutionDate: 'Fecha de ejecución',
  paymentExecutionDateCapital: 'Fecha de ejecución',
  dateReceived: 'Confirmación',
  noExistPrincipalEmailContact:
    'no existe un correo de contacto principal. Debes configurarlo.',
  areYouSureThisEmailContact:
    '¿Estás seguro de enviar el documento a este correo?',
  fromDate: 'Desde',
  toDate: 'Hasta',
  period: 'Cuota',
  pmtMethod: 'Método de pago',
  fees: 'Cargos',
  originalInvoice: 'Cuota',
  payment: 'Pago',
  downloadExcel: 'Descargar en Excel',
  downloadPdf: 'Descargar en Pdf',
  sendFileToEmails: 'Enviar archivo a correo(s)',
  executed: 'Ejecutado',
  received: 'Recibido',
  noDataFoundForReport: 'No se encontró información para el reporte',
  fileType: 'Tipo de archivo',
  yourLoan: 'Tu Préstamo',
  charges: 'Cargos',
  totalAmountDue: 'Total adeudado',
  pastDueAmount: 'Total en mora',
  currentlyMonthlyDue: 'Cuota mensual adeudada actualmente',
  installment: 'Cuota',
  linkToPay: 'Link de pago',
  copyLinkAndSendToCustomer: 'Copiar enlace y enviar al cliente',
  copy: 'Copiar',
  thisIsLinkToPay: 'Este es el enlace para pagar',
  loanNotFound: 'Prestamo no encontrado',
  paymentLinkCreatedSuccessfully: 'enlace de pago creado correctamente',
  termConditions: 'Términos y condiciones',
  newPayment: 'Nuevo pago',
  paymentLinkIsInvalid: 'El enlace de pago no es válido',
  disagree: 'En desacuerdo',
  agree: 'De acuerdo',
  areYouSureUseThisService:
    '¿Estás seguro que quieres utilizar este servicio para pagar tu préstamo?',
  paymentLink: 'Link de pago',
  downloadStatement: 'Descargar estado de cuenta',
  downloadPaymentPlan: 'Descargar Plan de Pagos',
  setAutoPaymentInfo: 'Actualizar información de pago',
  setAutoPayment: 'Información de pago',
  autoPaymentInfoUpdatedSuccessful:
    'Información de pago automática actualizada correctamente',
  areYouSureSendLinkThisEmailContact:
    '¿Estás seguro de que quieres enviar el enlace para modificar la información de pago automático a este email?',
  setPaymentInfoSentSuccessfully:
    'Link para actualizar la información de pago automática enviada correctamente',
  sendLinkUpdateAutoPaymentInfo:
    'Enviar enlace para actualizar la Información de pago',
  confirmSetAutoPayment: 'Confirmar actualización de pago automático',
  areYouSureYouWantToUpdateAutoPayment:
    '¿Está seguro de que desea actualizar la información de pago automático?',
  paymentExtension: 'Prórroga de pago',
  dateForPaymentExtension: 'Fecha para la prórroga del pago',
  paymentExtensionAddedSuccessfully: 'Prórroga de pago añadida con éxito',
  extensions: 'Extensiones',
  extensionAttachmentNotExist: 'Archivo adjunto no existente',
  loanPayments: 'Pagos',
  active: 'Activo',
  hasExtension: 'Extensión',
  overdue1To29: 'Mora 1 a 29',
  overdue30To59: 'Mora 30 a 59',
  overdue60To89: 'Mora 60 a 89',
  overdue90OrMore: 'Mora 90 días o más',
  delinquent31To59: 'Delictivo 31 a 59',
  delinquent60To89: 'Delictivo 60 a 89',
  delinquent90OrMore: 'Delictivo 90 días o más',
  useCurrentAccount: 'Utilizar la cuenta actual',
  noHasPaymentAccountConfigured: 'No tiene cuenta de pago configurada',
  noHasAutoPaymentParametersConfig:
    'No tiene configurados los parámetros de pago automático',
  noPaymentExtensions: 'No se encuentran extensiones de pago registradas',
  isPartialPayment: 'Pago parcial',
  requiredPartialPaymentIsChecked:
    'El pago parcial está marcado, debe ingresar el importe',
  ifPartialPayPaymentAmountMustBeGreaterThatZero:
    'Si es un pago parcial, el importe debe ser mayor a cero.',
  noPaymentExtensionConfigured: 'No hay extensión de pago configurada',
  removeExtension: 'Eliminar extensión',
  loanPaymentExtensionDeletedSuccessfully:
    'Prórroga de pago eliminada con éxito',
  paymentLinkProcess: 'Enlace de pago',
  automaticPayment: 'Pago automático',
  createdByCapital: 'Creado por',
  dateCreated: 'Fecha creación',
  approved: 'Aprobado',
  amountApplied: 'Monto aplicado',
  statements: 'Extractos',
  addStatement: 'Agregar estado',
  loanStatementsLoadedSuccessfully:
    'Extracto(s) de préstamo cargado(s) con éxito',
  loanStatementAttachmentDeletedSuccessfully:
    'Extracto de préstamo eliminado con éxito',
  loanStatementAttachmentNotExist: 'Extracto de préstamo no existente',
  loanStatementSavedSuccessfully: 'Extracto de préstamo guardado correctamente',
  dateClosed: 'Fecha cerrado',
  paymentLinkHasExpired:
    '¡El enlace de pago ha expirado! Contáctanos para un nuevo link de pago.',
  paymentLinkWillBeValid:
    'El enlace de pago tendrá una vigencia de 10 días, pasados estos diez días expirará. Tendrás que contactarnos para un nuevo link de pago.',
  paymentLinkWillExpired: 'El enlace de pago expirará',
  balanceAmount: 'Saldo',
  defaultDate: 'Fecha de impago',
  numberOfPaymentsReceived: 'Número de pagos recibidos',
  numberOfPaymentsMissed: 'Número de pagos no efectuados',
  principalLoanBalance: 'Saldo principal del préstamo en la fecha de impago',
  expensesIncurred: 'Gastos Incurridos',
  repossession: 'Embargo',
  repairs: 'Reparaciones',
  Insurance: 'Seguro',
  otherExpensesIncurred: 'Otro(s) gastos incurridos',
  paymentCollected: 'Pagos Cobrados',
  liquidationProceeds: 'Ingresos de liquidación',
  insuranceRefund: 'Reembolso del seguro',
  otherPaymentCollected: 'Otro(s) pagos cobrados',
  informationUpdatedSuccessfully: 'Información actualizada correctamente',
  informationReportIsEmpty: 'La información del reporte no existe',
  editChargeOffInformation: 'Editar Información del Préstamo Castigado',
  markAsSold: 'Marcar como vendido',
  areYouSureYouWantMarkLoanAsSold:
    '¿Está seguro de que desea marcar el préstamo como vendido?',
  sold: 'Vendido',
  processed: 'Procesado',
  initialPeriod: 'Periodo Inicial',
  beginningPrincipalBalance: 'Saldo Inicial',
  interest: 'Interés',
  installments: 'Total Cuotas',
  endingPeriod: 'Periodo Final',
  endingPrincipalBalance: 'Saldo Final',
  loansReceivable: 'Préstamos a cobrar',
  totalPayments: 'Total Pagos',
  accountsReceivableAging: 'Antigüedad de cuentas por cobrar',
  agingMethod: 'Método de consulta',
  current: 'Actual',
  f: 'Fecha del informe',
  andOver: 'y Más',
  numberOfPeriods: 'Número de periodos',
  periods: 'Periodos',
  amountAppliedCapital: 'Monto aplicado',
  pendingAmountCapital: 'Monto pendiente',
  portfolioBalance: 'Balance de cartera',
  method: 'Método',
  totalPrincipal: 'Total principal',
  totalInterest: 'Total interés',
  totalFees: 'Total cargos',
  paid: 'Pagado',
  loanClosure: 'Cierre del préstamo',
  files: 'Archivos',
  guaranteePaymentRequested: 'Pago de garantía solicitado',
  batchNumber: 'Número de lote',
  purchaseDate: 'Fecha de compra',
  purchaseAmount: 'Valor de la compra',
  premiumAmountPaid: 'Valor de la prima pagado',
  numberOfPaymentsMade: 'Número de pagos realizados',
  paymentsOfPrincipalMade: 'Pagos de principal realizados',
  principalBalanceDue: 'Saldo principal vencido',
  replaceOrMakeWhole: 'Sustituir o completar',
  editLoanParticipation: 'Editar Participación en el Préstamo',
  iBankLoanNumber: 'Número de préstamo de IBank',
  guaranteeAssignmentDate: 'Fecha de la garantía',
  dateDemandLetterSubmitted: 'Fecha de presentación de la carta de reclamación',
  dateOfLastPaymentReceived: 'Fecha del último pago recibido',
  defaultCalculation: 'Cálculo por defecto',
  principalBalanceDueAtDefault: 'Saldo de capital adeudado en caso de impago',
  repossessionExpenses: 'Gastos de reposesión',
  adjustedPrincipalAmount: 'Importe principal ajustado',
  ninetyDaysOfInterest: '90 días de intereses',
  totalLoss: 'Pérdida total',
  editLoanStateGuarantee: 'Editar garantía estatal del préstamo',
  guaranteedPrincipalAmount: 'Monto principal garantizado',
  interestAmountDue: 'Importe de los intereses adeudados',
  totalGuaranteePaymentRequested: 'Pago total de garantía solicitado',
  amountReceivedFromState: 'Importe recibido del Estado',
  unrecoveredLosses: 'Pérdidas no recuperadas',
  editLoanGuaranteePaymentRequested: 'Editar Pago de Garantía Solicitado',
  guaranteedPrincipalPercent: 'Porcentaje de capital garantizado',
  interestAmountDuePercent: 'Porcentaje de interés vencido',
  reportNotExist: 'Este reporte no existe',
  loanClosureFilesSavedSuccessfully: 'Archivo de cierre guardados con éxito',
  loanClosureFilesNotExist: 'Los archivos de cierre no existen',
  loadedSuccessfully: 'Cargado correctamente',
  informeGenerado: 'Informe generado',
  loanClosureFileDeletedSuccessfully: 'Fichero de cierre borrado con éxito',
  uploadedFiles: 'Archivos subidos',
  deleteFile: 'Borrar archivo',
  notificaciónEnviadaCorrectamente: 'Notificación enviada con éxito',
  readyToChargedOff: 'Listo para ser castigado',
  noFilesUploaded: 'No hay archivo(s) subido(s)',
  sendNotification: 'Enviar Notificación',
  areYouSureYouWantSendNotification:
    '¿Seguro que quieres enviar la notificación?',
  youMustUploadLoanClosureFiles:
    'Debe cargar los archivos de cierre del préstamo',
  'One Dark': 'One Dark',
  Acelera: 'Acelera',
  accounting: 'Contabilidad',
  dashboard: 'Dashboard',
  accountsReceivableSummary: 'Resumen Cuentas por Cobrar',
  yearToDateLoansReceivableSummary:
    'Resumen Préstamos por Cobrar Hasta la Fecha',
  dashboardOverview: 'Vista general',
  numberOfLoansFunded: 'Préstamos financiados',
  totalLoanPortfolioValue: 'Valor actual de la cartera de préstamos',
  averageLoanAmount: 'Importe promedio del préstamo',
  averageInterestRate: 'Tipo de interés promedio',
  averageOriginationFee: 'Comisión promedio de apertura',
  averageFicoCreditScore: 'Puntuación promedio de crédito FICO',
  loanBuyerOverview: 'Resumen de Préstamos Vendidos',
  numberOfLoansSold: 'Número de Préstamos Vendidos',
  valueOfLoansSold: 'Valor de los préstamos vendidos',
  averagePremiumAmount: 'Importe promedio de la prima premium',
  expirationDateUpdatedSuccessfully:
    'Fecha de expiración actualizada correctamente',
  insuranceExpirationInformation: 'Información sobre el vencimiento del seguro',
  showInsuranceExpirationInformation:
    'Mostrar información de vencimiento del seguro',
  insuranceCompanyName: 'Compañía de seguros',
  insuranceBrokerName: 'Nombre corredor de seguros',
  insuranceBrokerEmail: 'Correo del corredor de seguros',
  insuranceBrokerPhone: 'Teléfono del corredor de seguros',
  insuranceExpirationDateCapital: 'Fecha de vencimiento del seguro',
  noExistInsuranceExpirationInfo:
    'No existe información sobre la caducidad del seguro',
  insuranceExpirationCreateOrUpdatedSuccessfully:
    'Se ha creado o actualizado correctamente la caducidad del seguro',
  vinCode: 'Código VIN',
  insuranceAmount: 'Monto del seguro',
  hasCollectionActivity:
    'Este contacto tiene notificaciones de cobranza. No puedes eliminarlo',
  inputDateLastInstallment: 'Puede ser la fecha del último plazo pagado',
  numberInstallmentRemainingAddingGracePeriod:
    'Introduzca el número de plazos restantes añadiendo el período o períodos de gracia',
  inputDateInstallmentToBeDeffered:
    'Introduzca la fecha del plazo que se va a aplazar',
  inputNumberOfGracePeriod:
    'Introduzca el número del periodo de gracia a conceder',
  liquidatedCollateralAmount: 'Importe liquidado de la garantía',
  accruedInterestAmount: 'Importe de los intereses devengados',
  downloadDemandLetter: 'Descargar carta de reclamación',
  demandLetterSentToAllEmailsSuccessfully:
    'Carta de reclamación enviada a todos los correos electrónicos correctamente',
  defaultAndRepossession: 'Impago y Reposesión',
  chargedOffDate: 'Fecha castigado',
  reasonForChargeOff: 'Motivo de la cancelación',
  repossessionDate: 'Fecha de reposesión',
  repossessionType: 'Tipo de recuperación',
  repossessionCompanyName: 'Nombre de la empresa embargante',
  repossessionCost: 'Coste de la recuperación',
  conditionOfCollateral: 'Estado de la garantía',
  priceDigestValue: 'Valor del resumen del precio',
  liquidationDate: 'Fecha de liquidación',
  liquidationAmount: 'Importe de la liquidación',
  nameOfBuyer: 'Nombre del comprador',
  voluntary: 'Voluntaria',
  involuntary: 'Involuntario',
  good: 'Bueno',
  poor: 'Pobre',
  damaged: 'Dañado',
  totalLost: 'Perdida total',
  attachConditionReport: 'Adjuntar informe de condición',
  attachPriceDigestReport: 'Adjuntar informe de resumen de precios',
  attachBillSaleAndInvoice: 'Adjuntar factura de venta y factura',
  notSelected: 'No seleccionado',
  noExistDefaultAndRepossession: 'No existen Impago y Reposesión',
  informationSavedSuccessfully: 'Información guardada con éxito',
  attachmentsTo: 'Adjunto(s) a ',
  editDefaultAndRepossession: 'Editar Impago y Reposesión',
  loanSaleDetails: 'Detalles de la Venta',
  amountPurchased: 'Cantidad comprada',
  continuePaymentOrMakeWhole: 'Continuar con el pago o recuperar',
  continuePayment: 'Continuar pago',
  makeWhole: 'Reintegrar',
  editLoanSaleDetails: 'Editar Detalles de Venta',
  investorName: 'Nombre Inversor',
  getDataFromOpEx: 'Obtener datos de OpEx',
  getSaleDetailsFromExternalService:
    'Obtener detalles de venta del servicio externo',
  loanHasNotBeenSoldYet: 'El préstamo no se ha vendido todavía',
  stateGuaranteeNotFound: 'No se ha encontrado la garantía estatal',
  dateDemandLetterSubmittedNotExist:
    'La fecha de presentación de la carta de reclamación no existe',
  dateDemandLetterIsLessThanDateLastPaymentMade:
    'La fecha de la carta de reclamación es menor que la fecha del último pago realizado',
  getSaleDetails: 'Obtener detalles de venta',
  dateOfLastPaymentMadeToInvestor:
    'Fecha del último pago realizado al inversor',
  dateOfLastPaymentMade: 'Fecha del último pago realizado',
  investor: 'Inversor',
  investorAddress: 'Direccion Inversor',
  investorEmail: 'Email Inversor',
  downloadDraftNoticeDefaultInvestorV1:
    'Descargar borrador de notificación de impago de préstamo al inversor V1',
  dateOfNoticeLoanDefaultToInvestor:
    'Fecha de notificación del impago del préstamo al inversor',
  dateOfNoticeLoanDefault: 'Fecha de notificación del impago del préstamo',
  sendDraftDocumentToEmails:
    'Enviar borrador de documento a correo(s) electrónico(s)',
  signOffOnAmountsAndCalculations:
    'Dar el visto bueno a los importes y cálculos',
  areYouSureYouWantToSignOffOnAmountsAndCalculations:
    '¿Seguro que quiere firmar en Importes y Cálculos?',
  saleDetailsNotFound: 'Detalles de venta no encontrados',
  dateOfLastPaymentMadeToInvestorNotExist:
    'Fecha del último pago realizado al inversor no existe',
  noExistNotification: 'Notificación no existente',
  noticeLoanDefaultSentToAllEmailsSuccessfully:
    'Aviso de préstamo impagado enviado a todos los correos electrónicos con éxito',
  fileSavedSuccessfully: 'Archivo guardado correctamente',
  sendNoticeLoanDefaultToInvestor:
    'Enviar notificación de impago de préstamo al inversor',
  sendNoticeToInvestor: 'Enviar aviso al inversor',
  areYouSureYouWantToSendNoticeToInvestor:
    '¿Está seguro de que desea enviar notificación al inversor?',
  investorEmailIsNotValid: 'El correo electrónico del inversor no es válido',
  noticeLoanDefaultSentSuccessfully:
    'Aviso de impago de préstamo enviado correctamente',
  emailSentToServicingAndFileSavedSuccessfully:
    'Email enviado a servicing y archivo guardado con éxito',
  fileSavedSuccessfullyErrorSendingServicingEmail:
    'Archivo guardado con éxito pero, con un error al enviar el email a Servicing',
  downloadDraftDemandLetter: 'Descargar Borrador Carta de Demanda',
  signOnDemandLetter: 'Firmar la Carta de Reclamación',
  areYouSureYouWantToSignOnDemandLetter:
    '¿Seguro que quiere firmar en la Carta de Reclamación?',
  sendSignedDocumentToEmails:
    'Enviar documento firmado a correo(s) electrónico(s)',
  addEmailsToSendDocumentAsToAndCc:
    'Agregar correo(s) electrónico(s) para enviar documento(s) destinatario y Cc',
  addEmailAsTo: 'Añadir correo(s) electrónico(s) del destinatario',
  addedEmailsAsTo: 'Correo(s) electrónico(s) agregados del destinatario',
  emailAsTo: 'Correo electrónico del destinatario',
  addEmailAsCc: 'Agregar correo(s) electrónico(s) para Cc',
  addedEmailsAsCc: 'Correo(s) electrónico(s) agregados para Cc',
  emailAsCc: 'Correo electrónico para Cc',
  insuranceReport: 'Pólizas de seguros',
  expirationDate: 'Fecha de vencimiento',
  fortyFiveDays: '45 días',
  thirtyDays: '30 días',
  tenDays: '10 días',
  zeroDays: '0 día',
  insuranceNoteAddedSuccessfully: 'Nota de seguro añadida con éxito',
  noExistInsuranceNote: 'No existe nota de seguro',
  updatedSuccessfully: 'Actualizada con éxito',
  deletedSuccessfully: 'Eliminada con éxito',
  attachmentNotExist: 'No existe este archivo',
  insurance: 'Seguros',
  addInsuranceNote: 'Añadir nota de seguro',
  deleteInsuranceNote: 'Borrar nota de seguro',
  noInsurancesNotes: 'No se encuentran notas de seguros registradas',
  expired: 'Vencido',
  sent: 'Enviado',
  buyerInformation: 'Información del comprador',
  state: 'Estado',
  zip: 'Código postal',
  vehicleCollateralDetails: 'Detalles de la garantía del vehículo',
  vin: 'VIN',
  licensePlate: 'Matrícula',
  saleAmount: 'Importe de venta',
  saleDate: 'Fecha de venta',
  billOfSale: 'Factura de venta',
  downloadDraftBillOfSale: 'Descargar Borrador de Factura de Venta',
  editBillOfSale: 'Editar Factura de Venta',
  downloadDraftInvoice: 'Descargar Borrador Factura',
  documentsSentToAllEmailsSuccessfully:
    'Documento(s) enviado(s) a todos los correos electrónicos correctamente',
  billOfSaleNotFound: 'Documento de venta no encontrado',
  emailSubject: 'Asunto',
  emailBody: 'Cuerpo',
  generateAndSend: 'Generar y Enviar Documentos',
  areYouSureYouWantToSendFiles: '¿Seguro que quieres enviar los archivos?',
  confirmSendFilesToEmails: 'Confirma Enviar Archivos a Email(s)',
  created: 'Creado',
  updated: 'Actualizado',
  downloadFilteredReport: 'Descargar informe filtrado',
  downloadActiveInsuranceReport: 'Descargar informe de seguros activos',
  insPolicyOnFile: 'Póliza archivada',
  buyer: 'Comprador',
  invoiceNumber: 'Número de factura',
  invoice: 'Factura',
  collateral: 'Garantía',
  collateralReport: 'Informe de Venta de Garantía',
  downloadAllCollateralReport: 'Descargar informe de todas las garantías',
  coi: 'COI',
  paymentCycle: 'Ciclo de pago',
  cycle1st: '1ro',
  cycle15th: '15vo',
  downloadDraftNoticeDefaultInvestor:
    'Descargar borrador de impago de préstamo',
  defaultedLoansReport: 'Préstamos impagados',
  ibank: 'IBank',
  submitted: 'Presentado',
  initialLoan: 'Préstamo inicial',
  defaultedBalance: 'Saldo impagado',
  principalPaid: 'Principal pagado',
  pmtsMade: 'Pagos realizados',
  defaulted: 'Impagado',
  equipment: 'Equipo',
  initial: 'Inicial',
  liquidation: 'Liquidación',
  monthOfDefault: 'Mes del impago',
  daysToReceiveStateGuarantee: 'Número días para garantía del Estado',
  downloadAllLoansReport: 'Descargar reporte',
  eQLoanListReport: 'Préstamos vendidos',
  contract: 'Contrato',
  customerName: 'Nombre del cliente',
  financing: 'Financiación',
  downPmt: 'Pago inicial',
  closing: 'Costo de cierre',
  date: 'Fecha',
  int: 'Int',
  batch: 'Lote',
  monthlyPmt: 'Pago Mensual',
  loanSold: 'Préstamo Vendido',
  loanSales: 'Préstamo Vendido',
  pd: 'Pd',
  statementCycle: 'Ciclo del extracto',
  percentSold: 'Porcentaje vendido',
  premiumFee: 'Comisión de prima',
  servicingFee: 'Comisión de servicio',
  acqEffective: 'Adq Efectivo',
  balance: 'Saldo',
  premium: 'Premium',
  loanPurchase: 'Compra de préstamo',
  investment: 'Inversión',
  mthPmt: 'Pago mensual',
  irr: 'TIR',
  calculateIrr: 'Calcular TIR',
  dummy: 'Dummy',
  periodPurchased: 'Periodo comprado',
  successfullyButErrorInOpex: 'Con éxito, pero hubo un error en Opex',
  transactionDetails: 'Detalles de la Transacción',
  installmentDetails: 'Detalles de la cuota',
  termDate: 'Fecha del préstamo',
  filteredBy: 'Filterado por',
  amountDue: 'Importe a pagar',
  dateNotice: 'Fecha aviso',
  stateGuaranteeLoans: 'Préstamos IBank',
  vintagePortfolioLoans: 'Préstamos Portafolio Antiguo',
  vintagePortfolio: 'Portafolio Antiguo 2021 - 2023',
  numberOfDefaultedLoans: 'Número de préstamos impagados',
  defaultRate: 'Tasa de impago',
  ibankAmount: 'Importe recibido IBank',
  calCapLoans: 'Préstamos CalCAP SB',
  currentProgramLoans: 'Préstamos del Programa Actual',
  noRegistered: 'No registrado',
  showLoansFunded: 'Ver préstamos financiados',
  showDefaultedLoans: 'Ver préstamos impagados',
  showLoansSold: 'Ver préstamos vendidos',
  daysLate: 'Días retraso',
  creditEnhancementType: 'Tipo de mejora crediticia',
  stateGuarantee: 'IBank',
  calCap: 'CalCAP SB',
  calCapPortfolio: 'CalCAP Portfolio: 2024',
  loans: 'Préstamos',
  ineligible: 'No Elegible',
  areYouSureYouWantMarkLoanAsIneligible:
    '¿Está seguro de que desea marcar el préstamo como no elegible?',
  markAsIneligible: 'Marcar como no elegible',
  loanMarkedAsIneligible: 'préstamo marcado como no elegible',
  downloadLoanClosureMemo: 'Descargar nota de cierre de préstamo',
  searchLoans: 'Buscar préstamos',
  portfolioLoans: 'Cartera de préstamos',
  activeLoans: 'Préstamos activos',
  notifyAccounting: 'Notificar a Contabilidad',
  sendNotificationToAccounting: 'Enviar Notificación a Contabilidad',
  saveToSend: 'Guardar para enviar',
  sendNoticeDefaultLackInsurance:
    'Enviar notificación de impago por falta de seguro',
  downloadNoticeDefaultLackInsurance:
    'Descargar notificación de impago por falta de seguro',
  emailSentAndSavedSuccessfully:
    'Correo electrónico enviado y guardado correctamente',
  fileSavedSuccessfullyErrorSendingEmail:
    'Archivo guardado con éxito, con error al enviar el correo',
  areYouSureYouWantToSendNoticeDefaultLackInsurance:
    '¿Está seguro de que desea enviar el aviso de notificación de impago por falta de seguro?',
  voluntaryCollateralRelease: 'Liberación Voluntaria de Garantías',
  dateInformedVoluntaryReturn: 'Fecha informada de la devolución voluntaria',
  sendVoluntaryCollateralReleaseLetter:
    'Enviar carta de liberación voluntaria de garantía',
  downloadVoluntaryCollateralReleaseLetter:
    'Descargar carta de liberación voluntaria de garantía',
  areYouSureYouWantToSendVoluntaryCollateralReleaseLetter:
    '¿Está seguro de que desea enviar la carta de liberación voluntaria de garantías?',
  noticeLoanDefault: 'notificación de Impago de Préstamo',
  categoryFile: 'Categoría de los ficheros',
  uploadedByUser: 'Subido por el usuario',
  demandLetter: 'Carta de Demanda',
  watchList: 'Lista de vigilancia',
  monthlyPaymentDueDate: 'Fecha de vencimiento del pago mensual',
  totalPastDueAmount: 'Importe total vencido',
  call: 'Llamar',
  sendNotifications: 'Enviar notificaciones',
  amountInProcess: 'Monto en curso',
  signOff: 'Haga clic aquí para aprobar la carta de reclamación',
  nsf: 'NSF',
  borrowerProfileData: 'Datos del perfil del prestatario',
  ficoScore: 'Puntuación FICO',
  minFicoScore: 'Puntuación FICO mínima',
  maxFicoScore: 'Puntuación FICO máxima',
  yearsInBusiness: 'Años en el negocio',
  minYearsInBusiness: 'Años mínimos en el negocio',
  maxYearsInBusiness: 'Años máximos en el negocio',
  monthsInBusiness: 'Meses en el negocio',
  minMonthsInBusiness: 'Min Meses en el negocio',
  maxMonthsInBusiness: 'Max Meses en el negocio',
  downPaymentPercentage: 'Porcentaje de pago inicial',
  minDownPaymentPercentage: 'Porcentaje mínimo de pago inicial',
  maxDownPaymentPercentage: 'Porcentaje máximo de pago inicial',
  totalMonthlyBankDeposits: 'Depósitos bancarios mensuales totales',
  minTotalMonthlyBankDeposits: 'Depósitos bancarios mensuales totales máximos',
  maxTotalMonthlyBankDeposits: 'Depósitos bancarios mensuales totales máximos',
  numberOfPreviousLoans: 'Número de préstamos anteriores',
  minNumberOfPreviousLoans: 'Número mínimo de préstamos anteriores',
  maxNumberOfPreviousLoans: 'Número máximo de préstamos anteriores',
  typeOfBusiness: 'Tipo de entidad comercial',
  loanCharacteristics: 'Características del préstamo',
  minLoanAmount: 'Importe mínimo del préstamo',
  maxLoanAmount: 'Importe máximo del préstamo',
  loanTerm: 'Plazo del préstamo (meses)',
  minLoanTerm: 'Plazo mínimo del préstamo',
  maxLoanTerm: 'Plazo máximo del préstamo',
  minInterestRate: 'Tipo de interés mínimo',
  maxInterestRate: 'Tipo de interés máximo',
  minMonthlyPaymentAmount: 'Importe mínimo del pago mensual',
  maxMonthlyPaymentAmount: 'Importe máximo del pago mensual',
  loanToValueRatioAtOrigination: 'Relación préstamo-valor en origen',
  minLoanToValueRatioAtOrigination: 'Relación mínima entre préstamo y valor',
  maxLoanToValueRatioAtOrigination: 'Relación máxima entre préstamo y valor',
  originationFeeCharged: 'Comisión de apertura cobrada',
  minOriginationFeeCharged: 'Mínima comisión de apertura cobrada',
  maxOriginationFeeCharged: 'máxima comisión de apertura cobrada',
  timeFromApplicationToFunding:
    'Tiempo desde la solicitud hasta la financiación',
  minTimeFromApplicationToFunding:
    'Tiempo mínimo desde la solicitud hasta la financiación',
  maxTimeFromApplicationToFunding:
    'Tiempo máximo desde la solicitud hasta la financiación',
  collateralInformation: 'Información colateral',
  vehicleType: 'Tipo de vehículo',
  vehicleAgeAtOrigination: 'Año del vehículo',
  minVehicleAgeAtOrigination: 'Edad mínima del vehículo',
  maxVehicleAgeAtOrigination: 'Edad máxima del vehículo',
  vehicleMileageAtOrigination: 'Kilometraje del vehículo',
  minVehicleMileageAtOrigination: 'Kilometraje mínimo del vehículo',
  maxVehicleMileageAtOrigination: 'Kilometraje máximo del vehículo',
  vehicleManufacturer: 'Fabricante del vehículo',
  originalPurchasePrice: 'Precio de compra original',
  minOriginalPurchasePrice: 'Precio de compra original mínimo',
  maxOriginalPurchasePrice: 'Precio de compra original máximo',
  typeOfHauling: 'Tipo de transporte',
  paymentPerformance: 'Rendimiento del pago',
  numberOfLatePayments: 'Número de pagos atrasados (de por vida)',
  minNumberOfLatePayments: 'Número mínimo de pagos atrasados',
  maxNumberOfLatePayments: 'Número máximo de pagos atrasados',
  averageDaysLatePerPayment: 'Promedio de días de retraso por pago',
  minAverageDaysLatePerPayment: 'Promedio mínimo de días de retraso por pago',
  maxAverageDaysLatePerPayment: 'Promedio máximo de días de retraso por pago',
  numberOfNSF: 'Número de casos de fondos insuficientes',
  minNumberOfNSF: 'Número mínimo de fondos insuficientes',
  maxNumberOfNSF: 'Número máximo de fondos insuficientes',
  numberOfLoanExtensionsRequested: 'Número de extensiones de pago solicitadas',
  minNumberOfLoanExtensionsRequested:
    'Número mínimo de extensiones de pago solicitadas',
  maxNumberOfLoanExtensionsRequested:
    'Número máximo de extensiones de pago solicitadas',
  numberOfLoanExtensionsGranted: 'Número de extensiones de pago concedidas',
  minNumberOfLoanExtensionsGranted:
    'Número mínimo de extensiones de pago concedidas',
  maxNumberOfLoanExtensionsGranted:
    'Número máximo de extensiones de pago concedidas',
  numberOfLoanDeferralsRequested:
    'Número de aplazamientos de préstamo solicitados',
  minNumberOfLoanDeferralsRequested:
    'Número mínimo de aplazamientos de préstamo solicitados',
  maxNumberOfLoanDeferralsRequested:
    'Número máximo de aplazamientos de préstamo solicitados',
  numberOfLoanDeferralsGranted:
    'Número de aplazamientos de préstamo concedidos',
  minNumberOfLoanDeferralsGranted:
    'Número mínimo de aplazamientos de préstamo concedidos',
  maxNumberOfLoanDeferralsGranted:
    'Número máximo de aplazamientos de préstamo concedidos',
  longestConsecutiveStreak: 'Racha consecutiva más larga',
  minLongestConsecutiveStreak: 'Racha consecutiva mínima',
  maxLongestConsecutiveStreak: 'Racha consecutiva máxima',
  numberOfInsuranceLapses: 'Número de caducidades del seguro',
  minNumberOfInsuranceLapses: 'número mínimo de caducidades del seguro',
  maxNumberOfInsuranceLapses: 'Número máximo de caducidades del seguro',
  numberOfAchAutoDebitFailures: 'Número de fallos de débito automático ACH',
  minNumberOfAchAutoDebitFailures:
    'Número mínimo de fallos de débito automático',
  maxNumberOfAchAutoDebitFailures:
    'Número máximo de fallos de débito automático',
  dryVan: 'Furgoneta seca',
  flatbed: 'Plataforma',
  reefer: 'Máscara',
  riskManagement: 'Gestión de riesgos',
  createRiskManagement: 'Crear filtro de gestión de riesgos',
  editRiskManagement: 'Editar filtro de gestión de riesgos',
  newRiskManagementFilter: 'Nuevo filtro de gestión de riesgos',
  riskManagementFilterToDelete: 'Filtro de gestión de riesgos a eliminar',
  areYouSureYouWantToDeleteTheRiskManagementFilter:
    '¿Está seguro de que desea eliminar este filtro?',
  riskManagementFilterSavedOrUpdatedSuccessfully:
    'Filtro de gestión de riesgos guardado o actualizado correctamente',
  riskManagementFilterDeletedSuccessfully:
    'Filtro de gestión de riesgos eliminado correctamente',
  riskManagementFilterNoFound:
    'No se ha encontrado el filtro de gestión de riesgos',
  totalMonthlyBankDepositsTable: 'Depósitos bancarios mensuales',
  numberOfNSFTable: 'Número mínimo de fondos insuficientes',
  default: 'Por defecto',
  loanManagementReports: 'Informes de gestión de préstamos',
  interestPayment: 'Intereses de pago',
  downloadInterestPaymentDocument: 'Descargar documento de pago de intereses',
  sendInterestDocumentToPrincipalContact:
    'Enviar documento de intereses a contacto principal',
  interestPaymentDocumentSentSuccessfully:
    'Documento de pago de intereses enviado con éxito',
  interestPaymentDocumentSentToAllEmailsSuccessfully:
    'Documento de pago de intereses enviado a todos los correos electrónicos con éxito',
  historicalDataTape: 'Cinta de datos históricos',
  folderLink: 'Enlace a la carpeta',
  downloadReport: 'Descargar reporte',
  investorPaid: 'Inversor pagado',
  datePaid: 'Fecha saldo pagado',
  disbursementDate: 'Fecha de desembolso',
  minDisbursementDate: 'Fecha mínima de desembolso',
  maxDisbursementDate: 'Fecha máxima de desembolso',
  defaultsChargedOff: 'Impagos/Castigados',
  minLiquidationAmount: 'Importe mínimo de liquidación',
  maxLiquidationAmount: 'Importe máximo de liquidación',
  numberOfMissedPayments: 'Número de pagos atrasados',
  minNumberOfMissedPayments: 'Mínimo de pagos atrasados',
  maxNumberOfMissedPayments: 'Máximo de Pagos atrasados',
  minDefaultDate: 'Fecha mínima de impago',
  maxDefaultDate: 'Fecha máxima de impago',
  dateModified: 'fecha de modificación',
  portfolioPerformance: 'Rendimiento de la cartera',
  assistant: 'Asistente',
  whatCanIHelpWith: '¿En qué puedo ayudarle?',
  newChat: 'Nuevo Chat',
  useAssistant: 'User Asistente',
  modifiedBy: 'Modificado por',
  ai: 'IA',
  gemini: 'Gemini',
  dataIsEmpty: 'Los datos están vacíos',
  addFile: 'Añadir archivo(s)',
  askSomething: 'Preguntar algo',
  approveNoticeLoanDefault:
    'Haga clic aquí para aprobar la notificación de impago',
  dateReceivedGreaterDemandLetter:
    'La fecha de recepción debe ser mayor que la fecha de presentación de la carta de reclamación',
  averageLoanTerm: 'Plazo medio del préstamo',
  averageDownPayment: 'Anticipo medio',
  minusRepairsDone: 'Menos reparaciones realizadas',
  insuranceNotes: 'Notas',
  claims: 'Reclamos',
  newInsuranceClaim: 'Nuevo Reclamo de Seguro',
  claimNumber: 'Número de reclamo',
  filedDate: 'Fecha de presentación',
  insuranceCarrier: 'Aseguradora',
  pending: 'Pendiente',
  lastUpdateDate: 'Última actualización',
  areYouSureDeleteThisClaim:
    '¿Estás seguro de que quieres eliminar este reclamo?',
  loanClaimNotFound: 'Reclamo no encontrado',
  editInsuranceClaim: 'Editar Reclamo de Seguro',
  errorSavingInformation: 'Error al guardar la información',
  noClaims: 'No hay reclamo(s) registrado(s)',
  completedDate: 'Fecha de finalización',
  daysPending: 'Días pendientes',
  filedDateRange: 'Rango de fechas de presentación',
  amountRange: 'Rango de monto',
  daysPendingRange: 'Rango de días pendiente',
  minDaysPending: 'Días pendientes mínimo',
  maxDaysPending: 'Días pendientes máximo',
  totalAmountPendingClaims: 'Total de monto de reclamos pendientes',
  totalPendingClaims: 'Total de reclamos pendientes',
  investorAddressFirstPart: 'Dirección primera parte',
  investorAddressSecondPart: 'Dirección segunda parte',
  carrier: 'Transportistas',
  legalNameOrDBAName: 'Nombre legal o nombre comercial',
  dotNumber: 'Número DOT',
  docketNumber: 'Número Docket',
  allowedToOperate: 'Permitido para operar',
  bipdInsuranceOnFile: 'Seguro en el expediente',
  bipdInsuranceRequired: 'Seguro requerido',
  bipdRequiredAmount: 'Monto requerido',
  commonAuthorityStatus: 'Estatuto de autoridad común',
  contractAuthorityStatus: 'Estado de la autoridad contractual',
  crashTotal: 'choque total',
  dbaName: 'Nombre DBA',
  driverInsp: 'Insp. del conductor',
  legalName: 'Nombre legal',
  phyCity: 'Ciudad',
  phyCountry: 'País',
  phyState: 'Estado',
  phyStreet: 'Calle',
  phyZipcode: 'Zipcode',
  safetyRating: 'Calificación de seguridad',
  carrierOperationCode: 'Código',
  carrierOperationDesc: 'Descripción',
  carrierOperation: 'Operación del transportista',
  bipd: 'BIPD',
  consolidatedReport: 'Consolidado',
  paymentsReport: 'Pagos',
  report: 'Reporte',
  currentBalanceOwed: 'Sando actual adeudado',
  numberOfDaysLate: 'Número de días de retraso',
  minNumberOfDaysLate: 'Número mínimo de días de retraso',
  maxNumberOfDaysLate: 'Número máximo de días de retraso',
  delinquentLoans: 'Préstamos morosos',
  information: 'Información',
  certificates: 'Certificados',
  loanAgreements: 'Acuerdos de préstamo',
  noPolicies: 'No hay pólizas registradas',
  addInsurancePolicy: 'Añadir Póliza de Seguro',
  addedSuccessfully: 'Añadido con éxito',
  deleteInsurancePolicy: 'Delete Insurance Policy',
  noCertificates: 'No hay certificados registrados',
  addInsuranceCertificate: 'Añadir Certificado de Seguro',
  noAgreements: 'No hay acuerdos registrados',
  addLoanAgreement: 'Añadir Acuerdo de Préstamo',
  noExistInsurancePolicies: 'No existe(n) póliza(s) de seguro',
  insurancePoliciesLoadedSuccessfully:
    'Póliza(s) de seguro cargada(s) correctamente',
  noExistInsurancePolicy: 'No existe(n) póliza(s) de seguro',
  insurancePolicyAttachmentNotExist: 'Póliza de seguro Adjuntos no existen',
  noExistInsuranceCertificates: 'No existe(n) certificado(s) de seguro',
  insuranceCertificatesLoadedSuccessfully:
    'Certificado(s) de seguro cargado(s) correctamente',
  noExistInsuranceCertificate: 'No existe(n) certificado(s) de seguro',
  insuranceCertificateAttachmentNotExist:
    'Certificado de seguro Adjuntos no existen',
  noExistInsuranceAgreements: 'No existe(n) acuerdo(s) de seguro',
  insuranceAgreementsLoadedSuccessfully:
    'Acuerdo(s) de seguro cargado(s) correctamente',
  noExistInsuranceAgreement: 'No existe(n) acuerdo(s) de seguro',
  insuranceAgreementAttachmentNotExist: 'Acuerdo de seguro Adjuntos no existen',
  vehicleInformation: 'Información del vehículo',
  statedValue: 'Valor declarado',
  creditEnhancement: 'Mejora de crédito',
  loanPerformanceDashboard: 'Panel de Rendimiento del Préstamo',
  moreThanOneFile: 'Hay más de un archivo de este tipo, por favor revíselo',
  editDateCurrentBalancePaid: 'Editar Fecha Saldo Actual Pagado',
  datePaidCannotBeBeforeNoticeLoanDefault:
    'La Fecha Saldo Actual Pagado no puede ser anterior a la Fecha de Notificación de Incumplimiento del Préstamo',
  docusignDocuments: 'Documentos Docusign',
  noDocusignDocuments: 'No hay documentos de Docusign registrados',
  addDocusignDocument: 'Agregar documento de Docusign',
  docusignDocumentAddedSuccessfully: 'Documento Docusign agregado con éxito',
  showActiveLoans: 'Mostrar Préstamos Activos',
  defaultRateByYearsInBusiness: 'Tasa de impago por años en el negocio',
  lessThanTwoYears: 'Menos de 2 años',
  greaterThanOrEqualToTwoYears: 'Mayor o igual a 2 años',
  paymentHistoryByHaulType: 'Historial de Pagos por Tipo de Carga',
  outOfCalifornia: 'Fuera de California',
  inCalifornia: 'En California',
  both: 'Ambos',
  from1To29DaysLate: 'de 1 a 29 días de retraso',
  from30To59DaysLate: 'de 30 a 59 días de retraso',
  from60OrMoreDaysLate: 'de 60 o más días de retraso',
  assignmentLenderInterestSentToAllEmailsSuccessfully:
    'Interés del prestamista asignado enviado a todos los correos electrónicos con éxito',
  downloadAssignmentLenderInterest:
    'Descargar interés del prestamista asignado',
  sendSignedAssignmentLenderInterest:
    'Enviar interés del prestamista asignado firmado',
  sentAssignmentLenderInterest: 'Interés del prestamista asignado fue enviado',
  assignmentLenderInterest: 'Interés del prestamista asignado',
  defaultRateByDownPaymentPercent:
    'Tasa de incumplimiento (según el pago inicial)',
  twentyOrMoreDownPayment: '20% o más de pago inicial',
  lessThanTwentyDownPayment: 'Menos del 20% de pago inicial',
  defaultRateByLoanTerm: 'tasa de incumplimiento (por plazo de préstamo)',
  fortyEightMonthsOrLess: '48 meses o menos',
  sixtyOrMoreMonths: '60 o más meses',
  defaultRateByTruckAge: 'tasa de incumplimiento (por antigüedad del camión)',
  threeYearsOrLess: '3 años o menos',
  moreThanThereYears: 'Más de 3 años',
  northern: 'Norte',
  southern: 'Sur',
  central: 'Centro',
  loansByRegion: 'Préstamos por región',
  emailAlerts: 'Alertas de correo',
  microsoftGraphAPI: 'Microsoft Graph',
  gpsDeviceCode: 'Código dispositivo GPS',
  noEmailsAlerts: 'No hay alertas de correo registradas',
  lastNotificationDate: 'Fecha última notificación',
  sixtyDays: '60 días',
  downloadInsuranceFinancingReport:
    'Descargar Informe de Financiamiento de Seguros',
  receivedDate: 'Fecha de recepción',
  notificationFrom: 'Notificación de',
  showEmailContent: 'Mostrar contenido del correo',
  emailAlertNotFound: 'Alerta de correo no encontrada',
  fileDescription: 'Descripción del archivo',
  downloadNoticeClaimsDepartment:
    'Descargar Notificación al Departamento de Reclamaciones',
  noticeClaimDepartmentSentToAllEmailsSuccessfully:
    'Notificación al Departamento de Reclamaciones enviada a todos los correos electrónicos con éxito',
  sendNoticeClaimsDepartment:
    'Enviar Notificación al Departamento de Reclamaciones',
  productVehicleNotFound: 'Producto de vehículo no encontrado',
  soldTo: 'Vendido a',
  paidOffLetter: 'Carta de Pago',
  dateOfNoticePaidOffLetter: 'Fecha de Notificación de Carta de Pago',
  downloadPaidOffLetter: 'Descargar Carta de Pago',
  sendPaidOffLetter: 'Enviar Carta de Pago',
  paidOffLetterNoticeSentToAllEmailsSuccessfully:
    'Notificación de Carta de Pago enviada a todos los correos electrónicos con éxito',
  delinquencyNoticeReport: 'Notificaciones de Morosidad',
  delinquencyNoticeDocument: 'Documento de Notificación de Morosidad',
  loanPaidOffFilesNotExist: 'No existen archivos de pago',
  loanPaidOffFileDeletedSuccessfully: 'Archivo de pago eliminado con éxito',
  amountRemainingCompletePayment: 'Monto restante para completar un pago',
  noExistNotificationLoanPaymentExtensionAddedSuccessfully:
    'No existe notificación. Extensión de pago agregada con éxito',
  paymentExtensionAddedAndEmailSuccessfully:
    'Prórroga de pago añadida y correo electrónico enviado con éxito',
  errorSendingEmailPaymentExtensionAddedSuccessfully:
    'Error al enviar el correo electrónico. Prórroga de pago añadida con éxito',
  note: 'Nota',
  sendInsuranceClaim: 'Enviar carta de reclamo completada al prestatario',
  downloadInsuranceClaim: 'Descargar carta de reclamo completada',
  claimNotFound: 'Reclamo no encontrado',
  insuranceClaimSentToAllEmailsSuccessfully:
    'Reclamo de Seguro enviado a todos los correos electrónicos con éxito',
  activeClaim: 'Reclamo Activo',
  valuation: 'Valoración',
  blackBookValue: 'Valor del Libro Negro',
  averageValue: 'Valor Promedio',
  outstandingPrincipalBalance: 'Saldo Principal Pendiente',
  valuationVehicleInformation: 'Información de Valoración del Vehículo',
  originalEquipmentValue: 'Valor original del equipo',
  collateralValuationReport: 'Informe de Valoración de Garantías',
  updateDate: 'Última actualización el',
  titleDocuments: 'Documentos de Título',
  viewDocuments: 'Ver Documento(s)',
  eqLoansPortfolio: 'Portafolio Préstamos EQ',
  principalPayments: 'Pagos de Capital',
  automaticPaymentExtension: 'Extensión de Pago Automática',
  totalPrincipalPaid: 'Total Principal Pagado',
  totalInterestPaid: 'Total Interés Pagado',
  totalFeesPaid: 'Total de Comisiones Pagadas',
  chargedOffAmount: 'Monto Castigado',
  paymentExtensions: 'Extensiones de Pago',
  deferralDetails: 'Detalles del Aplazamiento',
  preApprovedDeferral: 'Aplazamiento Preaprobado',
  deferralApproval: 'Aprobación',
  skip: 'Saltar',
  finish: 'Finalizar',
  reset: 'Restablecer',
  stepsCompleted: 'Todos los pasos para el aplazamiento completados',
  paymentDeferrals: 'Aplazamientos de Pago',
  reschedule: 'Reestructurar',
  stepNotSkippable: 'Paso no se puede saltar',
  paymentDeferralNotExist: 'El aplazamiento de pago no existe',
  unexpectedErrorSendingEmailStepSavedSuccessfully:
    'Error inesperado al enviar el correo electrónico. Paso guardado con éxito.',
  rescheduleSavedSuccessfully: 'Reestructuración guardada con éxito',
  stepCannotBeSkipped: 'No puedes saltar un paso que no es opcional',
  categorizedDocuments: 'Documentos Categorizados',
  documents: 'Documentos',
  customReport: 'Informe Personalizado',
  monthlyStatements: 'Extractos Mensuales',
  liquidatedCollateralAmountIsLessThanZero:
    '¡El importe liquidado de la garantía es menor que cero! Por favor, revise los montos ingresados.',
  approvedDemandLetter: 'Carta de Reclamación Aprobada',
  approvalRevocationRequired:
    'Si necesita realizar cambios y no tiene permiso para revocar la aprobación, debe solicitarlo al departamento de contabilidad.',
  requestRevokeApproval: 'Solicitar revocación de aprobación',
  revokeApproval: 'Revocar aprobación',
  areYouSureYouWantToRevokeApproval:
    '¿Está seguro de que desea revocar la aprobación de la ',
  demandLetterApprovalRevokedSuccessfully:
    'Aprobación de la Carta de Reclamación revocada con éxito',
  demandLetterSentToEmails:
    'Carta de Reclamación Aprobada enviada a los correos electrónicos',
  requestRevokeApprovalSent: 'Solicitud de revocación de aprobación enviada',
  requestSentSuccessfully: 'Solicitud enviada con éxito',
  unexpectedErrorSendingRequest: 'Error inesperado al enviar la solicitud',
  userNotHavePermission: 'El usuario no tiene permiso para aprobar',
  approvalRevocationAndEmailSentSuccessfully:
    'Revocación de aprobación y notificación enviada con éxito',
  downPaymentPercentageHdt: 'Pago inicial %',
  closingCostPercentage: 'Costo de cierre %',
  simulation: 'Simulación',
  letters: 'Cartas',
  sendForSignature: 'Enviar para firma',
  deferralOfPaymentLetter: 'Deferral of Payment.pdf',
  amendmentToPromissoryNoteReDeferralsLetter:
    'Amendment to Promissory Note Re Deferrals.pdf',
  letterNotExist: 'La carta no existe',
  paymentPlanSimulationNotFound: 'Simulación de plan de pago no encontrada',
  areYouSureThisEmailContactNotification:
    '¿Está seguro de que desea enviar la notificación a este correo electrónico?',
  sendForSignatureSuccessfully: 'Enviado para firma con éxito',
  simulationSavedSuccessfully: 'Simulación guardada con éxito',
  lettersavedSuccessfully: 'Cartas guardadas con éxito',
  existMoreThanOneNoticeLoanDefault:
    'Existe más de una notificación de impago de préstamo',
  companyReserve: 'Reserva de la Empresa',
  endingPrincipalBalanceDifferentOutstandingPrincipalBalance:
    'El saldo principal final es diferente al saldo principal pendiente',
  loanToBeChargedOff: 'Préstamo a ser castigado',
  supplementaryTextForDemandLetter:
    'Texto suplementario para la Carta de Reclamación',
  paragraphFourOfDemandLetter: 'Párrafo cuatro de la Carta de Reclamación',
  currentValue: 'Valor Actual',
  avgAmount: 'Promedio de Monto',
  avgRate: 'Promedio de Tasa',
  avgTerm: 'Promedio de Plazo',
  avgDownPmt: 'Promedio de Pago Inicial',
  loansSold: 'Préstamos Vendidos',
  valueSold: 'Valor Vendido',
  portfolioPerformanceSegments: 'Segmentos del Portafolio',
  totalPortfolioValue: 'Valor Total del Portafolio',
  totalActiveLoans: 'Total de Préstamos Activos',
  averageLtvRatio: 'Promedio de LTV',
  averageLtvRatioNoClosing: 'Promedio de LTV',
  noClosingCosts: 'Sin Costos de Cierre',
  totalLoansSold: 'Total de Préstamos Vendidos',
  ofDefaults: 'de Incumplimientos',
  noticeLoanDefaultApproved: 'Notificación de Impago de Préstamo Aprobada',
  noticeLoanDefaultSentToEmails:
    'Notificación de Impago de Préstamo enviada a los correos electrónicos',
  plaidTransactions: 'Transacciones de Plaid',
  valueIsNullOrEmpty: 'Valor es requerido',
  connectBankViaPlaid: 'Conectar Banco (via Plaid)',
  getTransactionsFromBank: 'Traer transacciones del banco',
  merchantName: 'Nombre del comerciante',
  paymentChannel: 'Canal de pago',
  financeCategory: 'Categoría de finanzas',
  plaidConnectedSuccessfully: 'Plaid conectado correctamente',
  otherVins: 'Otros VINs',
  addOtherVin: 'Agregar otro VIN',
  editOtherVin: 'Editar VIN',
  deleteOtherVin: 'Eliminar VIN',
  noOtherVins: 'No hay otros VINs registrados',
  otherVinNotFound: 'VIN no encontrado',
  searchByDisbursementDate: 'Buscar por fecha de desembolso',
  searchBySaleDate: 'Buscar por fecha de venta',
  nameOfTheInsured: 'Nombre del asegurado',
  seekCourtJudgement: 'Buscar sentencia judicial',
  downloadSeekCourtJudgement: 'Descargar PDF de búsqueda de sentencia judicial',
  licenseClass: 'Clase de licencia',
  licenseNonDomCdl: 'Non-Dom CDL',
  suspendedFtb: 'FTB - suspendido',
  valid: 'Válido',
  cdlJurisdiction: 'Jurisdicción CDL',
  driverLicenses: 'Licencias de conducir',
  driverName: 'Conductor',
  downloadPoliciesReport: 'Descargar informe de pólizas',
  downloadDriverLicenseReport: 'Descargar informe de licencias de conducir',
  searchByExpirationDate: 'Buscar por fecha de vencimiento',
  dateReceivedFromState: 'Fecha de recepción del estado',
  searchByCreationDate: 'Buscar por fecha de creación',
  searchByDefaultedDate: 'Buscar por fecha de incumplimiento',
  searchByClearedDate: 'Buscar por fecha de liquidación',
  searchByReceivedDate: 'Buscar por fecha de recepción',
  searchByStatusChangeDate: 'Buscar por fecha cambio de estado',
  searchByDueDate: 'Buscar por fecha de vencimiento',
  monthlyPaymentDay: 'Día Pago Mensual',
  citizenshipStatus: 'Situación de ciudadanía',
  visaWorkPermitExpirationDate:
    'Fecha de caducidad visado o permiso de trabajo',
  stateGuaranteeDetails: 'Detalles de la Garantía del Estado',
  sendToEmails: 'Enviar a los correos electrónicos',
  initialInvestmentAndPayments:
    'En caso de impago del préstamo, este valor representa la inversión inicial (incluida la prima) y resta todos los pagos realizados al inversor hasta la fecha del impago.',
  referralFee: 'Tarifa de referencia',
  paymentDueDay: 'Día de pago',
  totalLoansOriginated: 'Total de préstamos originados',
  totalNumberOfLoansOriginated: 'Total número de préstamos originados',
  totalValueOfLoansFunded: 'Valor préstamos financiados',
  collateralReports: 'Informes de Garantía',
  vehicles: 'Vehículos',
  areYouSureSendInvitationToThisBorrower:
    '¿Estás seguro de que quieres enviar una invitación para acceder al Portal de Prestatarios a este cliente?',
  sendingInvitationToBorrowerPortal:
    'Enviando invitación al Portal de Prestatarios',
  identificationNumberNotFound: 'Número de identificación no encontrado',
  emailAlreadyInUse: 'Correo electrónico ya en uso',
  invitationSentSuccessfully: 'Invitación enviada con éxito',
  enterNewBankAccountInfo:
    'Ingresa a continuación los datos de tu nueva cuenta bancaria para realizar un pago.',
  bankAccountInfoNote:
    'El número de cuenta bancaria y el número de ruta que ingreses se almacenarán de manera segura y se utilizarán para todos los pagos automáticos futuros, a menos que vuelvas a actualizar tu información de pago.',
  loanChangedAndNotificationSent:
    'El préstamo ha sido modificado y la notificación enviada con éxito',
  loanChangedAndNotificationFailed:
    'El préstamo ha sido modificado pero la notificación falló al enviarse',
  downloadPaymentDefaultNotice:
    'Descargar Notificación de Incumplimiento de Pago',
  sendPaymentDefaultNotice: 'Enviar Notificación de Incumplimiento de Pago',
  areYouSureYouWantToSendPaymentDefaultNotice:
    '¿Estás seguro de que quieres enviar la Notificación de Incumplimiento de Pago?',
  enterVin: 'Ingrese VIN',
  enterBorrowerName: 'Ingrese Nombre del Prestatario',
  enterMake: 'Ingrese Marca',
  enterModel: 'Ingrese Modelo',
  enterYear: 'Ingrese Año',
  lossPayeeEndorsement: 'Endoso de Beneficiario de Pérdida',
  lossPayablesEndorsement: 'Endoso de Pagadores de Pérdida',
  policyDeclarationPage: 'Página de Declaración de Póliza',
  borrowersAndcontacts: 'Prestatarios y Contactos',
  contact: 'Contacto',
  contactName: 'Nombre del Contacto',
  enterLoanCode: 'Ingrese Código de Préstamo',
  enterContactName: 'Ingrese Nombre del Contacto',
  enterPhone: 'Ingrese Teléfono',
  enterEmail: 'Ingrese Correo Electrónico',
  enterAddress: 'Ingrese Dirección',
  paymentsMadeToDate: 'Pagos realizados hasta la fecha',
  totalPaymentsMade: 'Total de pagos realizados',
  showNote: 'Mostrar nota',
  attachmentsAdded: 'Adjuntos agregados',
  noAttachments: 'No hay adjuntos registrados',
  editInsuranceNote: 'Editar nota de seguro',
  ok: 'Aceptar',
  showAllNotes: 'Mostrar todas las notas',
  lastNote: 'Última nota',
  loanSaleDetailsNotExist: 'Los detalles de la venta del préstamo no existen',
  mileageAtOrigination: 'Kilometraje en origen',
  paymentReportSentToAllEmailsSuccessfully:
    'Informe de pago enviado a todos los correos electrónicos con éxito',
  paymentStatus: 'Estado de pago',
  paidOff: 'Pagado',
  dateOfNoticeLoanPaidOff: 'Fecha notificación pago completado'
};
